// src/Admin.js - 管理者希望編集機能追加版（エラー修正）【改善版】
import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import { createPortal } from "react-dom";
//import { getAuth, onAuthStateChanged } from "firebase/auth";
// ✅ Firebase（レガシーコード用 - 段階的に削除）
//import { db } from "./firebase";
//import { collection, getDocs, setDoc, doc, getDoc, writeBatch } from "firebase/firestore";

// ✅ Supabase（新機能用）
import { supabase } from "./supabase";
import { writeClientAudit } from "./utils/auditClient";
import { saveAs } from "file-saver";
// emailjs は催促機能のアプリ内通知化に伴い削除 (元: import emailjs from "@emailjs/browser")
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { OrganizationService } from './services/organizationService';
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import { 
  Save, 
  RotateCcw, 
  Download, 
  Mail, 
  Search, 
  ClipboardList, 
  ChevronLeft, 
  ChevronRight,
  MessageSquare,
  Loader,
  Bell,
  AlertTriangle,
  Info,
  CheckCircle,
  XCircle,
  Calendar,
  Users,
  TrendingUp,
  Settings,
  Activity,
  Eye,
  EyeOff,
  ChevronDown,
  ChevronUp,
  Edit3,
  UserCheck,
  RefreshCw,
  AlertCircle
} from "lucide-react";
import FeedbackForm from "./FeedbackForm";
import Header from "./components/ui/Header";
import ShiftAssignmentModal from "./components/ShiftAssignmentModal";
import DailyRequirementOverrideModal from "./components/DailyRequirementOverrideModal";
import DayShiftOnlyPanel from "./components/DayShiftOnlyPanel";
import RecurringEventModal from "./components/RecurringEventModal";
import { runFullAutoAssignment, calculateRequiredStaff } from "./utils/shiftAutoAssign";
import V2TrialModal from "./components/V2TrialModal";
import { 
  fetchYearlyShiftHistory, 
  calculateFairMonthlyAssignments 
} from "./utils/yearlyHistoryUtils";
import { categorizeStaffIntoGroups } from "./utils/staffGroupUtils";
import { useOrganization } from './contexts/OrganizationContext';
import {
  checkHopeConflictsWithGroups,
  sendConflictNotifications,
  createConflictResolutionTasks,
  notifyAdminsAboutPendingTasks
} from "./utils/hopeConflictUtils";


dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

const today = dayjs();
const defaultDate = today.date() <= 10
  ? today.add(1, "month")  // 翌月
  : today.add(2, "month"); // 翌々月

const defaultMonth = defaultDate.month() + 1;  // 1-12の月
const defaultYear = defaultDate.year();        // 🔥 追加：年も取得

// モダンなスタイル定数（改善版）
const modernStyles = {
  container: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    minHeight: '100vh',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  contentWrapper: {
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(20px)',
    borderRadius: '24px',
    margin: '20px',
    padding: '32px',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
  },
  // 新規追加：編集モード用のオーバーレイスタイル
  editModeOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    zIndex: 999,
    pointerEvents: 'none', // 要素をクリックできるようにする
  },
  
  // 編集モード時のメインコンテンツ
  editModeContent: {
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(20px)',
    borderRadius: '24px',
    margin: '20px',
    padding: '32px',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    position: 'relative',
    zIndex: 1000,
  },
  
  // 編集モード表示バナー
  editModeBanner: {
    position: 'fixed',
    top: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    background: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
    color: 'white',
    padding: '12px 24px',
    borderRadius: '50px',
    fontSize: '16px',
    fontWeight: '700',
    zIndex: 1001,
    boxShadow: '0 8px 25px rgba(22, 163, 74, 0.4)',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    animation: 'pulse 2s infinite',
  },
  
  // 固定保存ボタン
  fixedSaveButton: {
    position: 'fixed',
    bottom: '30px',
    right: '30px',
    background: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '50px',
    padding: '16px 24px',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer',
    zIndex: 1001,
    boxShadow: '0 8px 25px rgba(22, 163, 74, 0.4)',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  
  header: {
    background: 'linear-gradient(135deg, #1e3a8a 0%, #3730a3 100%)',
    color: 'white',
    padding: '24px 32px',
    borderRadius: '16px',
    marginBottom: '32px',
    boxShadow: '0 10px 25px rgba(30, 58, 138, 0.3)',
  },
  monthSelector: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '24px',
    marginBottom: '32px',
    background: 'white',
    padding: '20px',
    borderRadius: '16px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    border: '1px solid rgba(0, 0, 0, 0.05)',
  },
  monthButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 20px',
    border: 'none',
    borderRadius: '12px',
    background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
    color: 'white',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '0 4px 15px rgba(249, 115, 22, 0.3)',
  },
  actionGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
    gap: '20px',
    marginBottom: '32px',
  },
  actionCard: {
    background: 'white',
    borderRadius: '16px',
    padding: '24px',
    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(0, 0, 0, 0.05)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    cursor: 'pointer',
  },
  primaryButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    width: '100%',
    padding: '16px 24px',
    border: 'none',
    borderRadius: '12px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    position: 'relative',
    overflow: 'hidden',
  },
  tableContainer: {
    background: 'white',
    borderRadius: '20px',
    overflow: 'hidden',
    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
    border: '1px solid rgba(0, 0, 0, 0.05)',
    marginBottom: '32px',
  },
  tableHeader: {
    background: 'linear-gradient(135deg, #1f2937 0%, #374151 100%)',
    color: 'white',
    padding: '20px 24px',
    fontSize: '18px',
    fontWeight: '700',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  statusBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '600',
    color: 'white',
  },
  progressBar: {
    width: '100%',
    height: '8px',
    background: 'rgba(0, 0, 0, 0.1)',
    borderRadius: '4px',
    overflow: 'hidden',
    margin: '16px 0',
  },
  progressFill: {
    height: '100%',
    background: 'linear-gradient(90deg, #10b981 0%, #059669 100%)',
    borderRadius: '4px',
    transition: 'width 0.3s ease-in-out',
  },
  alertCard: {
    background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
    border: '1px solid #f59e0b',
    borderRadius: '16px',
    padding: '20px',
    marginBottom: '24px',
    boxShadow: '0 4px 15px rgba(245, 158, 11, 0.2)',
  },
  legendContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    padding: '20px',
    background: 'white',
    borderRadius: '16px',
    marginBottom: '24px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    border: '1px solid rgba(0, 0, 0, 0.05)',
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 16px',
    borderRadius: '20px',
    background: 'rgba(0, 0, 0, 0.02)',
    fontSize: '14px',
    fontWeight: '500',
  },
  staffSummaryHorizontal: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
    alignItems: 'center',
    fontSize: '10px',
    padding: '4px',
  },
  shiftBadgeHorizontal: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '3px',
    padding: '2px 6px',
    borderRadius: '8px',
    fontSize: '9px',
    fontWeight: '600',
    minWidth: '35px',
    justifyContent: 'center',
    border: '1px solid',
    position: 'relative',
  },
  detailToggleButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 12px',
    border: '1px solid #d1d5db',
    borderRadius: '8px',
    background: 'white',
    color: '#374151',
    fontSize: '12px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
  },
  // 希望編集モード（簡素化版）
  hopeEditModeSimple: {
    background: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)',
    border: '2px solid #16a34a',
    borderRadius: '12px',
    padding: '16px',
    marginBottom: '24px',
    boxShadow: '0 4px 15px rgba(22, 163, 74, 0.2)',
    position: 'relative',
    zIndex: 1000,
  },
  hopeEditButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 16px',
    border: '1px solid #d1d5db',
    borderRadius: '8px',
    background: 'white',
    color: '#374151',
    fontSize: '12px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
  },
  hopeSelector: {
    width: '100%',
    padding: '2px',
    borderRadius: '4px',
    border: '1px solid #d1d5db',
    fontSize: '10px',
    background: 'white',
    color: '#374151',
  },
  consecutiveBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '2px 8px',
    borderRadius: '12px',
    fontSize: '11px',
    fontWeight: '700',
    marginTop: '6px',
  },
  normalConsecutive: {
    background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
    color: '#1e40af',
  },
  warningConsecutive: {
    background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
    color: '#92400e',
  },
  dangerConsecutive: {
    background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
    color: '#991b1b',
  },
  maxConsecutiveCell: {
    background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%) !important',
    boxShadow: '0 0 0 2px rgba(239, 68, 68, 0.3) inset',
  },

  // ✅ 集中モード用スタイル
  focusModeContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: '#1f2937',
    zIndex: 9999,
    overflow: 'auto',
    padding: '20px',
  },
  focusModeHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    padding: '16px 24px',
    background: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '12px',
    backdropFilter: 'blur(10px)',
  },
  focusModeCloseButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 20px',
    background: 'rgba(239, 68, 68, 0.9)',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600',
    transition: 'all 0.2s ease',
  },
  focusModeTable: {
    background: 'white',
    borderRadius: '16px',
    overflow: 'hidden',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.4)',
  },
};

function shuffleArray(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

function Admin() {
  // 既存のState定義
  const { currentOrganization, currentUser } = useOrganization();
  const [events, setEvents] = useState({});
  const [uniqueEmployeeIds, setUniqueEmployeeIds] = useState([]);
  const [dates, setDates] = useState([]);
  const [shiftMatrix, setShiftMatrix] = useState({});
  // シフト公開状態 (shift_publications に行があれば公開済み)
  const [isPublished, setIsPublished] = useState(false);
  const [publishing, setPublishing] = useState(false);
  // 🔥 当月の前 30 日分のシフト（月またぎ連勤の正確な計算用）。
  //   { "empId_YYYY-MM-DD": "displayMark" }
  const [priorMonthMatrix, setPriorMonthMatrix] = useState({});
  // 年累計集計用：{ [empId]: { [mark]: cumulative count from Jan 1 to end of selected month } }
  const [annualHolidayCounts, setAnnualHolidayCounts] = useState({});
  const [hopes, setHopes] = useState({}); // 統合された希望データ
  // 🧪 V2 試算モーダル表示状態 (V1 ロジックとは完全に独立。 保存なしの dry-run 専用)
  const [v2TrialOpen, setV2TrialOpen] = useState(false);
  // currentUser は OrganizationContext から取得（上の destructure を参照）。
  // 旧 Firebase 時代の useState は削除済（常に null で context の値を覆ってしまうため）。
  const [staffList, setStaffList] = useState([]);
  const [unsubmitted, setUnsubmitted] = useState([]);
  const [showFeedback, setShowFeedback] = useState(false);
  const [loading, setLoading] = useState(true);
  const [submittedStaffIds, setSubmittedStaffIds] = useState(new Set());
  const [nightDutyCount, setNightDutyCount] = useState({});
  const [onCallDutyCount, setOnCallDutyCount] = useState({});
  const [dayShiftCount, setDayShiftCount] = useState({});
  const [nightShiftCount, setNightShiftCount] = useState({});
  const [lateCShiftCount, setLateCShiftCount] = useState({});
  const [onCallShiftCount, setOnCallShiftCount] = useState({});
  const [freeShiftCount, setFreeShiftCount] = useState({});
  // 🔥 月切替後にリロードしても元の月が維持されるよう localStorage から復元
  const [currentMonth, setCurrentMonth] = useState(() => {
    try {
      const saved = localStorage.getItem('admin_selected_month');
      const n = saved ? Number(saved) : NaN;
      return Number.isInteger(n) && n >= 1 && n <= 12 ? n : defaultMonth;
    } catch { return defaultMonth; }
  });
  const [selectedYear, setSelectedYear] = useState(() => {
    try {
      const saved = localStorage.getItem('admin_selected_year');
      const n = saved ? Number(saved) : NaN;
      return Number.isInteger(n) && n >= 2000 && n <= 2100 ? n : defaultYear;
    } catch { return defaultYear; }
  });

  // 月/年が変わるたびに localStorage に保存
  useEffect(() => {
    try {
      localStorage.setItem('admin_selected_month', String(currentMonth));
      localStorage.setItem('admin_selected_year', String(selectedYear));
    } catch { /* ignore */ }
  }, [currentMonth, selectedYear]);
  const [skillData, setSkillData] = useState({});
  const [saving, setSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [staff, setStaff] = useState({});
  const [assignedShifts, setAssignedShifts] = useState({});
  const [holidays, setHolidays] = useState([]);
  const [settings, setSettings] = useState({});
  const [shiftPatterns, setShiftPatterns] = useState([]);
  const [showAssignmentModal, setShowAssignmentModal] = useState(false);
  const [autoAssignmentResult, setAutoAssignmentResult] = useState(null);
  const [lastJobTypeFilter, setLastJobTypeFilter] = useState(null);
  const [showDailyOverrideModal, setShowDailyOverrideModal] = useState(false);
  const [showRecurringEventModal, setShowRecurringEventModal] = useState(false);
  // 当月のオーバーライド一覧（モーダル外でも常時表示用）
  const [monthlyOverrides, setMonthlyOverrides] = useState([]);
  const [shiftAnalysis, setShiftAnalysis] = useState(null);
  const [progressPercent, setProgressPercent] = useState(0);
  const [excludedStaff, setExcludedStaff] = useState([]);
  const [shiftTypeCounts, setShiftTypeCounts] = useState({ counts: {}, types: {} });
  const [sortMethod, setSortMethod] = useState('priority');
  const [useGrouping, setUseGrouping] = useState(true);
  const [showDetailedCounts, setShowDetailedCounts] = useState(false);
  const [isFocusMode, setIsFocusMode] = useState(false);
  const [focusModeTab, setFocusModeTab] = useState('shift');
  const [selectedCells, setSelectedCells] = useState([]); // [{empId, date}, ...]
  const [clipboardData, setClipboardData] = useState([]); // コピーしたデータ
  const [lastSelectedCell, setLastSelectedCell] = useState(null); // 範囲選択用
  const [dropdownCell, setDropdownCell] = useState(null); // ドロップダウン表示中のセル
  // 🔥 Portal でドロップダウンを描画するための位置。viewport 座標。
  //    集中モードのスクロールコンテナ (overflow: scroll) からドロップダウンを
  //    逃がして、選択肢が外枠に隠れず全部見えるようにする。
  const [dropdownAnchor, setDropdownAnchor] = useState(null); // {top, left, width}
  const [shortcutKeyMap, setShortcutKeyMap] = useState({}); // {key: shiftValue}
const [showShortcutSettings, setShowShortcutSettings] = useState(false);

  // 新しいState: 希望編集機能用（修正版）
  const [originalHopes, setOriginalHopes] = useState({}); // 個人提出の元希望
  const [adminHopes, setAdminHopes] = useState({}); // 管理者が設定した希望（全体）
  const [savedAdminHopes, setSavedAdminHopes] = useState({}); // 最後に保存した管理者希望

  const [jobTypes, setJobTypes] = useState([]);
  const [selectedJobType, setSelectedJobType] = useState(null); // null = 最初の職種

  // 新しいState: スタッフ順序カスタマイズ機能用
const [customStaffOrder, setCustomStaffOrder] = useState([]);
const [savedStaffOrder, setSavedStaffOrder] = useState([]);
const [isOrderEditMode, setIsOrderEditMode] = useState(false);
const [isDragging, setIsDragging] = useState(false);
const [draggedStaffId, setDraggedStaffId] = useState(null);
const [dragOverIndex, setDragOverIndex] = useState(-1);
const [savingOrder, setSavingOrder] = useState(false);


  // メール送信は廃止 (催促は staff_notifications によるアプリ内通知に移行)
  const ADMIN_EMAILS = ["admin@example.com"];
  const [shiftOptions, setShiftOptions] = useState(["", "◯"]);

  // 希望選択肢の定義（動的生成用にuseStateに変更）
const [hopeOptions, setHopeOptions] = useState([
  { value: "", label: "設定なし" },
  { value: "off", label: "休み希望" }
]);

// { "empId_date": "コメント内容" }
const [shiftComments, setShiftComments] = useState({}); 

  // シフトパターンの取得

useEffect(() => {
  const fetchShiftOptions = async () => {
    try {
      const organizationId = currentOrganization?.id;
  
      let query = supabase
        .from('shift_patterns')
        .select('*')
        .eq('is_active', true)
        .order('display_order', { ascending: true });
  
      if (organizationId) {
        query = query.eq('organization_id', organizationId);
      }
  
      const { data: patternsData, error } = await query;
  
      if (error) {
        console.error("❌ Supabaseシフトパターン取得エラー:", error);
        throw error;
      }
  
      // Firebaseデータ形式に変換
      const formattedPatterns = (patternsData || []).map(p => ({
        id: p.id,
        name: p.name,
        shortName: p.short_name,
        displayMark: p.short_name,
        color: p.color,
        configuration: p.configuration || {},
        displayOrder: p.display_order,
        startTime: p.start_time,
        endTime: p.end_time,
        requiredCount: p.required_count || {},
        priority: p.priority,

        // 🔥 ここに追加：configuration の中身を展開
  requiredByDayOfWeek: p.configuration?.required_by_day_of_week || p.required_count || {},
  flexibilityType: p.configuration?.flexibility_type || "flexible",
  targetGroup: p.configuration?.target_group || "",
  postShiftIds: p.configuration?.post_shift_ids || [],
  groupName: p.configuration?.group_name || "",
  isChainOnlyPattern: p.configuration?.is_chain_only_pattern || false,
  minRequired: p.configuration?.min_required || 0,
  forceAssign: p.configuration?.force_assign || false,
  maxConsecutive: p.configuration?.max_consecutive || 6,
  holidayAdjustment: p.configuration?.holiday_adjustment || "default",
  // 集計欄表示用（パターン横断で「集計に出すかどうか」を制御）
  //   公休（マーク「休」）は明示 false でない限り表示する（デフォルト ON）
  showInAggregation: (() => {
    const v = p.configuration?.show_in_aggregation;
    if (v === true) return true;
    if (v === false) return false;
    return p.short_name === '休';
  })(),
  holidayAnnualTotal:
    p.configuration?.holiday_annual_total != null
      ? Number(p.configuration.holiday_annual_total)
      : null,
  holidayMonthlyLimit:
    p.configuration?.holiday_monthly_limit != null
      ? Number(p.configuration.holiday_monthly_limit)
      : null,
  // 月毎の詳細設定 { "1": 8, "2": 7, ... }（null なら未設定）
  holidayMonthlyLimitByMonth:
    p.configuration?.holiday_monthly_limit_by_month
    && typeof p.configuration.holiday_monthly_limit_by_month === 'object'
      ? p.configuration.holiday_monthly_limit_by_month
      : null,
  aggregationPeriod: p.configuration?.aggregation_period === 'annual' ? 'annual' : 'monthly',
  showAcquisitionRate: (() => {
    const v = p.configuration?.show_acquisition_rate;
    if (v === true) return true;
    if (v === false) return false;
    return p.short_name === '休';
  })(),
      }));
  
      setShiftPatterns(formattedPatterns);

      // 🔥 デバッグログ追加
console.log("✅ シフトパターン取得:", formattedPatterns.length, "件");
console.log("\n📋 全パターン詳細:");
formattedPatterns.forEach(p => {
  console.log(`━━━━━━━━━━━━━━━━━━━━━━`);
  console.log(`パターン: ${p.name} (${p.displayMark})`);
  console.log(`  targetGroup: ${p.targetGroup || "なし"}`);
  console.log(`  requiredByDayOfWeek:`, p.requiredByDayOfWeek);
  console.log(`  flexibilityType: ${p.flexibilityType}`);
  console.log(`  postShiftIds:`, p.postShiftIds);
  console.log(`  isChainOnlyPattern: ${p.isChainOnlyPattern}`);
  console.log(`  configuration:`, p.configuration);
});
console.log(`━━━━━━━━━━━━━━━━━━━━━━\n`);
      
      // 🔥 シフト選択肢を生成（シフトセレクター用）
      const shiftSelectOptions = ["", ...formattedPatterns.map(p => p.shortName || p.name)];
      setShiftOptions(shiftSelectOptions);
      
      // ✅ 希望選択肢を生成（短縮マーク + 色情報対応版）
const hopeSelectOptions = [];
const seenGroups = new Set();

formattedPatterns
  .filter(p => {
    const config = p.configuration || {};
    return config.canReceiveRequest || config.can_receive_request;
  })
  .forEach(p => {
    const config = p.configuration || {};
    const groupId = config.requestGroup || config.request_group;
    
    if (groupId && !seenGroups.has(groupId)) {
      seenGroups.add(groupId);
      hopeSelectOptions.push({
        value: groupId,
        label: config.request_display_mark || config.requestDisplayMark || groupId,  // ✅ 短縮マーク
        fullLabel: config.request_group_label || config.requestGroupLabel || p.name,
        color: config.request_color || config.requestColor || '#166534'  // ✅ 色情報
      });
    }
  });

// 「未設定」オプションを最初に追加
hopeSelectOptions.unshift({ 
  value: "", 
  label: "-",
  fullLabel: "未設定",
  color: '#9ca3af'
});

setHopeOptions(hopeSelectOptions);
      
    } catch (error) {
      console.error("勤務パターン読み込みエラー:", error);
      setShiftPatterns([]);
      setShiftOptions(["", "◯"]);
      setHopeOptions([
        { value: "", label: "未設定" },
        { value: "休", label: "休" }
      ]);
    }
  };
  
  fetchShiftOptions();
}, [currentOrganization?.id]);

useEffect(() => {
  const fetchJobTypes = async () => {
    if (!currentOrganization?.id) return;
    const { data, error } = await supabase
      .from('job_types')
      .select('id, name, display_order')
      .eq('organization_id', currentOrganization.id)
      .order('display_order', { ascending: true });
    if (!error && data && data.length > 0) {
      setJobTypes(data);
      setSelectedJobType(data[0].id); // 最初の職種をデフォルト選択
    }
  };
  fetchJobTypes();
}, [currentOrganization?.id]);
  
  // ❌ コメントアウト
/*
useEffect(() => {
  const auth = getAuth();
  const unsubscribe = onAuthStateChanged(auth, (user) => {
    if (!user) {
      navigate('/login');
    }
  });
  return () => unsubscribe();
}, [navigate]);
*/

  
// 🔥 カスタムスタッフ順序を一時的に無効化
// カスタムスタッフ順序の読み込み（Supabase版）
const fetchCustomStaffOrder = async (year, month) => {
  try {
    if (!currentOrganization?.id) {
      console.error('組織IDが取得できません');
      return;
    }
    const organizationId = currentOrganization.id;
    
    const { data, error } = await supabase
      .from('custom_staff_order')
      .select('*')
      .eq('organization_id', organizationId)
      .eq('year', year)
      .eq('month', month)
      .single();
    
    if (error) {
      if (error.code === 'PGRST116') {
        // データが見つからない場合（新規）
        setCustomStaffOrder([]);
        setSavedStaffOrder([]);
        return [];
      }
      throw error;
    }
    
    const order = data?.staff_order || [];
    setCustomStaffOrder(order);
    setSavedStaffOrder([...order]);
    return order;
    
  } catch (error) {
    console.error("カスタムスタッフ順序取得エラー:", error);
    setCustomStaffOrder([]);
    setSavedStaffOrder([]);
    return [];
  }
};

// カスタムスタッフ順序の保存（Supabase版 + 自動保存対応）
const saveCustomStaffOrder = async (showNotification = true) => {
  setSavingOrder(true);
  
  try {
    const year = selectedYear;
    const title = `${year}年${currentMonth}月`;
    if (!currentOrganization?.id) {
      console.error('組織IDが取得できません');
      return;
    }
    const organizationId = currentOrganization.id;
    
    // 🔥 Supabaseに保存
    const { error } = await supabase
      .from('custom_staff_order')
      .upsert({
        organization_id: organizationId,
        year: year,
        month: currentMonth,
        staff_order: customStaffOrder,
        updated_at: new Date().toISOString()
      }, { 
        onConflict: 'organization_id,year,month' 
      });
    
    if (error) {
      console.error("❌ Supabase順序保存エラー:", error);
      throw error;
    }
    
    setSavedStaffOrder([...customStaffOrder]);
    
    // 通知表示（オプション）
    if (showNotification) {
      const notification = document.createElement('div');
      notification.innerHTML = `
        <div style="
          position: fixed; 
          top: 80px; 
          left: 50%; 
          transform: translateX(-50%); 
          background: linear-gradient(135deg, #16a34a 0%, #15803d 100%); 
          color: white; 
          padding: 12px 24px; 
          border-radius: 25px; 
          z-index: 10000;
          font-weight: 600;
          box-shadow: 0 8px 25px rgba(22, 163, 74, 0.4);
          animation: saveNotification 2s ease-in-out forwards;
        ">
          ✅ スタッフ順序を保存しました
        </div>
        <style>
          @keyframes saveNotification {
            0% { opacity: 0; transform: translateX(-50%) translateY(-20px); }
            15%, 85% { opacity: 1; transform: translateX(-50%) translateY(0); }
            100% { opacity: 0; transform: translateX(-50%) translateY(-20px); }
          }
        </style>
      `;
      document.body.appendChild(notification);
      
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 2000);
    }
    
  } catch (error) {
    console.error("❌ カスタムスタッフ順序保存エラー:", error);
    
    const errorNotification = document.createElement('div');
    errorNotification.innerHTML = `
      <div style="
        position: fixed; 
        top: 80px; 
        left: 50%; 
        transform: translateX(-50%); 
        background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%); 
        color: white; 
        padding: 12px 24px; 
        border-radius: 25px; 
        z-index: 10000;
        font-weight: 600;
        box-shadow: 0 8px 25px rgba(220, 38, 38, 0.4);
        animation: errorNotification 3s ease-in-out forwards;
      ">
        ❌ 順序保存に失敗しました
      </div>
      <style>
        @keyframes errorNotification {
          0% { opacity: 0; transform: translateX(-50%) translateY(-20px); }
          15%, 85% { opacity: 1; transform: translateX(-50%) translateY(0); }
          100% { opacity: 0; transform: translateX(-50%) translateY(-20px); }
        }
      </style>
    `;
    document.body.appendChild(errorNotification);
    
    setTimeout(() => {
      if (errorNotification.parentNode) {
        errorNotification.parentNode.removeChild(errorNotification);
      }
    }, 3000);
    
  } finally {
    setSavingOrder(false);
  }
};



// スタッフの順序を1つ上へ移動（デバッグ版）
const moveStaffUp = async (empId) => {
  
  const currentOrder = customStaffOrder.length > 0 
    ? [...customStaffOrder] 
    : getSortedStaffIds(staffList, []);
  
  const currentIndex = currentOrder.indexOf(empId);
  
  if (currentIndex > 0) {
    [currentOrder[currentIndex - 1], currentOrder[currentIndex]] = 
    [currentOrder[currentIndex], currentOrder[currentIndex - 1]];
    
    setCustomStaffOrder(currentOrder);
    
    // 🔥 即座に保存（デバッグログ追加）
    await saveCustomStaffOrderImmediately(currentOrder);
  } else {
  }
};

// スタッフの順序を1つ下へ移動（デバッグ版）
const moveStaffDown = async (empId) => {
  
  const currentOrder = customStaffOrder.length > 0 
    ? [...customStaffOrder] 
    : getSortedStaffIds(staffList, []);
  
  const currentIndex = currentOrder.indexOf(empId);
  
  if (currentIndex < currentOrder.length - 1) {
    [currentOrder[currentIndex], currentOrder[currentIndex + 1]] = 
    [currentOrder[currentIndex + 1], currentOrder[currentIndex]];
    
    setCustomStaffOrder(currentOrder);
    
    // 🔥 即座に保存（デバッグログ追加）
    await saveCustomStaffOrderImmediately(currentOrder);
  } else {
  }
};

// 即座保存用の関数（通知なし）
const saveCustomStaffOrderImmediately = async (orderToSave) => {
  try {
    const year = selectedYear;
    if (!currentOrganization?.id) {
      console.error('組織IDが取得できません');
      return;
    }
    const organizationId = currentOrganization.id;
    
    console.log("💾 即座保存実行中...", orderToSave.length, "件");
    
    const { error } = await supabase
      .from('custom_staff_order')
      .upsert({
        organization_id: organizationId,
        year: year,
        month: currentMonth,
        staff_order: orderToSave,
        updated_at: new Date().toISOString()
      }, { 
        onConflict: 'organization_id,year,month' 
      });
    
    if (error) {
      console.error("❌ Supabase順序保存エラー:", error);
      throw error;
    }
    
    // 🔥 保存成功時にsavedStaffOrderを更新
    setSavedStaffOrder([...orderToSave]);
    
    console.log("✅ 即座保存完了");
    
  } catch (error) {
    console.error("❌ 即座保存エラー:", error);
  }
};



// スタッフIDリストを適切な順序でソート
// ✅ 修正版
// スタッフIDリストを適切な順序でソート
const getSortedStaffIds = (staffList, customOrder) => {
  if (!customOrder || customOrder.length === 0) {
    return staffList
      .sort((a, b) => Number(a.year) - Number(b.year))
      .map(s => s.employeeId);
  }
  
  const sorted = [];
  const staffMap = new Map(staffList.map(s => [s.employeeId, s]));
  
  customOrder.forEach(empId => {
    if (staffMap.has(empId)) {
      sorted.push(empId);
      staffMap.delete(empId);
    }
  });
  
  const remaining = Array.from(staffMap.values())
    .sort((a, b) => Number(a.year) - Number(b.year))
    .map(s => s.employeeId);
  
  return [...sorted, ...remaining];
};

// 職種でフィルタリングされたスタッフIDリスト
const getFilteredStaffIds = () => {
  const sorted = getSortedStaffIds(staffList, customStaffOrder);
  if (!selectedJobType) return sorted;
  return sorted.filter(empId => {
    const s = staffList.find(s => s.employeeId === empId);
    return s?.job_type_id === selectedJobType;
  });
};

// ドラッグ&ドロップハンドラー
const handleDragStart = (e, empId) => {
  setDraggedStaffId(empId);
  setIsDragging(true);
  e.dataTransfer.effectAllowed = 'move';
  e.dataTransfer.setData('text/html', empId);
  
  // ドラッグ中の視覚的フィードバック
  e.target.style.opacity = '0.5';
};

const handleDragEnd = (e) => {
  setDraggedStaffId(null);
  setIsDragging(false);
  setDragOverIndex(-1);
  e.target.style.opacity = '1';
};

const handleDragOver = (e, targetIndex) => {
  e.preventDefault();
  e.dataTransfer.dropEffect = 'move';
  setDragOverIndex(targetIndex);
};

const handleDragLeave = () => {
  setDragOverIndex(-1);
};

const handleDrop = (e, targetIndex) => {
  e.preventDefault();
  
  if (!draggedStaffId) return;
  
  const currentOrder = customStaffOrder.length > 0 
    ? [...customStaffOrder] 
    : getSortedStaffIds(staffList, []);
  
  const draggedIndex = currentOrder.indexOf(draggedStaffId);
  
  if (draggedIndex === -1) {
    // ドラッグされたスタッフが順序にない場合は追加
    currentOrder.splice(targetIndex, 0, draggedStaffId);
  } else {
    // 既存の順序から削除して新しい位置に挿入
    currentOrder.splice(draggedIndex, 1);
    const newTargetIndex = targetIndex > draggedIndex ? targetIndex - 1 : targetIndex;
    currentOrder.splice(newTargetIndex, 0, draggedStaffId);
  }
  
  setCustomStaffOrder(currentOrder);
  setDragOverIndex(-1);
  
  console.log("🔄 スタッフ順序を変更:", {
    draggedStaff: draggedStaffId,
    fromIndex: draggedIndex,
    toIndex: targetIndex,
    newOrder: currentOrder
  });
};

  // 管理者希望データの読み込み（Supabase版）
const fetchAdminHopes = async (year, month) => {
  try {
    if (!currentOrganization?.id) {
      console.error('組織IDが取得できません');
      return;
    }
    const organizationId = currentOrganization.id;
    
    // 対象月の全日付を取得
    const startOfMonth = dayjs(`${year}-${String(month).padStart(2, "0")}-01`);
    const endOfMonth = startOfMonth.endOf("month");
    const startDate = startOfMonth.format("YYYY-MM-DD");
    const endDate = endOfMonth.format("YYYY-MM-DD");
    
    // Supabaseのadmin_shift_overridesテーブルから取得
    const { data: adminOverrides, error } = await supabase
      .from('admin_shift_overrides')
      .select('*')
      .eq('organization_id', organizationId)
      .gte('shift_date', startDate)
      .lte('shift_date', endDate);
    
    if (error) {
      console.error("❌ Supabase管理者希望取得エラー:", error);
      throw error;
    }
    
    // データをFirebase形式に変換（キー: "empId_date", 値: selection）
    const adminHopesMap = {};
    (adminOverrides || []).forEach(override => {
      const key = `${override.employee_id}_${override.shift_date}`;
      adminHopesMap[key] = override.selection;
    });
    
    setAdminHopes(adminHopesMap);
    setSavedAdminHopes({ ...adminHopesMap }); // 保存済み状態も同期
    
  } catch (error) {
    console.error("管理者希望データ取得エラー:", error);
    setAdminHopes({});
    setSavedAdminHopes({});
  }
};

  // 希望データを統合する関数
  const mergeHopes = (originalHopes, adminHopes) => {
    const merged = { ...originalHopes };
    
    // 管理者が設定した希望で上書き
    Object.keys(adminHopes).forEach(key => {
      merged[key] = adminHopes[key];
    });
    
    return merged;
  };

  // データ取得関数（希望編集機能対応版）
  const fetchData = async () => {
    setLoading(true);
    
    try {
      const year = selectedYear;
      if (!currentOrganization?.id) {
        console.error('組織IDが取得できません');
        return;
      }
      const organizationId = currentOrganization.id;
      
      // 🔥 Step 1: 日付配列生成（これは必須で即座に完了）
      const startOfMonth = dayjs(`${year}-${String(currentMonth).padStart(2, "0")}-01`);
      const endOfMonth = startOfMonth.endOf("month");
      const monthDates = [];
      let currentDate = startOfMonth;
      while (currentDate.isSameOrBefore(endOfMonth)) {
        monthDates.push(currentDate.format("YYYY-MM-DD"));
        currentDate = currentDate.add(1, "day");
      }
      setDates(monthDates);
  
      // 🔥 Step 2: 並列データ取得（最も効果的な改善）
      
      const [
        holidaysResult,
        settingsResult,
        staffResult,
        hopesResult,
        adminHopesResult,
        customOrderResult,
        savedShiftsResult,
        priorShiftsResult,
        recurringEventsResult,
      ] = await Promise.all([
        // 休日データ
        supabase
          .from('holidays')
          .select('*')
          .eq('year', year)
          .or(`organization_id.eq.${organizationId},is_public.eq.true`),
        
        // 設定データ
        supabase
          .from('holiday_policies')
          .select('*')
          .eq('organization_id', organizationId)
          .single(),
        
        // スタッフデータ
        supabase
          .from('staff')
          .select('*')
          .eq('organization_id', organizationId)
          .eq('is_active', true),
          
        
        // 個人希望データ
        supabase
        .from('shift_requests')
        .select('*')
        .eq('organization_id', organizationId)
        .gte('shift_date', monthDates[0])
        .lte('shift_date', monthDates[monthDates.length - 1])
        .range(0, 9999) ,  // ← 追加
        
        // 管理者希望データ
        supabase
          .from('admin_shift_overrides')
          .select('*')
          .eq('organization_id', organizationId)
          .gte('shift_date', monthDates[0])
          .lte('shift_date', monthDates[monthDates.length - 1])
          .range(0, 9999) ,  // ← 追加
        
        // カスタムスタッフ順序
        supabase
          .from('custom_staff_order')
          .select('*')
          .eq('organization_id', organizationId)
          .eq('year', year)
          .eq('month', currentMonth)
          .single(),
        
        // 保存済みシフト
        supabase
          .from('monthly_shifts')
          .select('*')
          .eq('organization_id', organizationId)
          .gte('shift_date', monthDates[0])
          .lte('shift_date', monthDates[monthDates.length - 1])
          .range(0, 9999),  // ← 追加

        // 🔥 前月末から続く連勤の正確な計算用に、当月の前 30 日分も取得
        supabase
          .from('monthly_shifts')
          .select('employee_id, shift_date, shift_type')
          .eq('organization_id', organizationId)
          .gte('shift_date', dayjs(monthDates[0]).subtract(30, 'day').format('YYYY-MM-DD'))
          .lt('shift_date', monthDates[0])
          .range(0, 9999),

        // 🔥 リカーリングイベント (期間が当月と重なるもの全部)
        supabase
          .from('recurring_events')
          .select('*')
          .eq('organization_id', organizationId)
          .lte('event_date', monthDates[monthDates.length - 1])
          .order('event_date'),
      ]);
      
      
  
      // 🔥 Step 3: データ処理（取得したデータを加工）
      
      // 休日データ
      const holidaysData = holidaysResult.data || [];
      const allHolidayDates = holidaysData.map(h => h.date).filter(Boolean);
      const uniqueHolidays = [...new Set(allHolidayDates)].sort();
      setHolidays(uniqueHolidays);
      
  
      // 設定データ
      const policyData = settingsResult.data;
      const holidayPolicy = policyData ? {
        annualTarget: policyData.annual_target || 120,
        monthlyMin: policyData.monthly_min || 8,
        monthlyMax: policyData.monthly_max || 11,
        weeklyBaseline: policyData.weekly_baseline || 2.0,
        maxConsecutiveWorkDays: policyData.max_consecutive_work_days || 6.0
      } : {
        annualTarget: 120,
        monthlyMin: 8,
        monthlyMax: 11,
        weeklyBaseline: 2.0,
        maxConsecutiveWorkDays: 6.0
      };
      setSettings({ holidayPolicy });
  
      // スタッフデータ
      const rawStaffData = (staffResult.data || []).map(s => ({
        id: s.id,
        employeeId: s.employee_id,
        lastName: s.last_name,
        firstName: s.first_name,
        email: s.email || "",
        year: s.year || "9999",
        excludeFromAutoAssign: s.exclude_from_auto_assign || false,
        customShiftPattern: s.custom_shift_pattern || {},
        job_type_id: s.job_type_id || null,
        dayShiftOnly: !!s.day_shift_only,
        dayShiftOnlyMode: s.day_shift_only_mode || 'all',
      }));
      
      const sortedStaffData = rawStaffData.sort((a, b) => Number(a.year) - Number(b.year));
      setStaffList(sortedStaffData);
      
      const excluded = sortedStaffData.filter(s => s.excludeFromAutoAssign);
      setExcludedStaff(excluded);
      
      const staffObj = {};
      sortedStaffData.forEach(s => {
        staffObj[s.employeeId] = s;
      });
      setStaff(staffObj);
      
      const registeredEmployeeIds = sortedStaffData.map(s => s.employeeId);
      
  
      // 個人希望データ
      const originalHopeMap = {};
      const submittedIds = new Set();
      const shiftCommentMap = {};
      
      (hopesResult.data || []).forEach(request => {
        const empId = request.employee_id;
        if (!empId) return;
        
        submittedIds.add(empId);
        const key = `${empId}_${request.shift_date}`;
        originalHopeMap[key] = request.selection || "";

        if (request.comment) {
          shiftCommentMap[key] = request.comment;
        }
        
      });
      setShiftComments(shiftCommentMap);
      
      setOriginalHopes(originalHopeMap);
      setSubmittedStaffIds(submittedIds);
      setUnsubmitted(registeredEmployeeIds.filter(id => !submittedIds.has(id)));
      
      
      
  
      // 管理者希望データ
      const adminHopesMap = {};
      (adminHopesResult.data || []).forEach(override => {
        const key = `${override.employee_id}_${override.shift_date}`;
        adminHopesMap[key] = override.selection;
      });
      
      setAdminHopes(adminHopesMap);
      setSavedAdminHopes({ ...adminHopesMap });

      // 🔥 リカーリングイベントを (empId × date) → イベント情報 にフラット展開
      //   target_staff_ids (個別) または target_skill_group (グループ) を解釈
      //   期間 [event_date, event_end_date] 内の各日に展開
      //   結果は events state に保存され、シフト表セルにマーカー表示される
      const eventMap = {};
      const recurringEventsData = recurringEventsResult.data || [];
      const monthStart = monthDates[0];
      const monthEnd = monthDates[monthDates.length - 1];
      recurringEventsData.forEach((ev) => {
        // 対象スタッフ ID 一覧を抽出
        const targetEmpIds = new Set();
        if (Array.isArray(ev.target_staff_ids) && ev.target_staff_ids.length > 0) {
          ev.target_staff_ids.forEach((sid) => {
            const staffMember = (staffResult.data || []).find((s) => String(s.id) === String(sid));
            if (staffMember?.employee_id) targetEmpIds.add(String(staffMember.employee_id));
          });
        } else if (ev.target_skill_group) {
          // スキルグループは後段で展開される想定
        }

        // 対象日の集合を計算: event_dates (複数モード) > event_date..event_end_date (期間/単日)
        const dateStrSet = new Set();
        if (Array.isArray(ev.event_dates) && ev.event_dates.length > 0) {
          ev.event_dates.forEach((d) => { if (typeof d === 'string') dateStrSet.add(d); });
        } else {
          const startDate = ev.event_date;
          const endDate = ev.event_end_date || ev.event_date;
          if (!startDate) return;
          if (endDate < monthStart || startDate > monthEnd) return;
          const startD = dayjs(startDate);
          const endD = dayjs(endDate);
          for (let d = startD; d.isBefore(endD.add(1, 'day')); d = d.add(1, 'day')) {
            dateStrSet.add(d.format('YYYY-MM-DD'));
          }
        }

        dateStrSet.forEach((dateStr) => {
          if (dateStr < monthStart || dateStr > monthEnd) return;
          targetEmpIds.forEach((empId) => {
            const key = `${empId}_${dateStr}`;
            eventMap[key] = ev.name || ev.event_name || 'イベント';
          });
        });
      });
      setEvents(eventMap);
      console.log(`📅 リカーリングイベント展開: ${recurringEventsData.length}件 → ${Object.keys(eventMap).length}セル`);

      // カスタムスタッフ順序
      const order = customOrderResult.data?.staff_order || [];
      setCustomStaffOrder(order);
      setSavedStaffOrder([...order]);
  
      // スタッフ順序の適用
      const sortedEmployeeIds = getSortedStaffIds(sortedStaffData, order);
      setUniqueEmployeeIds(sortedEmployeeIds);
  
      // シフトマトリックス初期化
      const matrix = {};
      registeredEmployeeIds.forEach(empId => {
        monthDates.forEach(date => {
          matrix[`${empId}_${date}`] = "";
        });
      });
  
      // カスタムシフトパターン適用
      applyCustomShiftPatterns(matrix, sortedStaffData, monthDates);
  
      // 保存済みシフトデータ
      // 保存済みシフトデータ
console.log("📥 DBから取得したシフト件数:", savedShiftsResult.data?.length);
console.log("📥 DBサンプル3件:", savedShiftsResult.data?.slice(0, 3));

(savedShiftsResult.data || []).forEach(shift => {
  const key = `${shift.employee_id}_${shift.shift_date}`;
  
  if (shift.employee_id === '222335') {
    console.log(`📌 222335のDB値: ${shift.shift_date} → "${shift.shift_type}"`);
    console.log(`📌 matrixキー: "${key}"`);
  }
  
  matrix[key] = shift.shift_type || "";
});

console.log("📌 matrix['222335_2026-03-02']:", matrix['222335_2026-03-02']);

      setShiftMatrix(matrix);

      // 🔥 前月末セルを priorMonthMatrix に反映（月またぎ連勤計算用）
      const priorMx = {};
      (priorShiftsResult?.data || []).forEach((shift) => {
        priorMx[`${shift.employee_id}_${shift.shift_date}`] = shift.shift_type || '';
      });
      setPriorMonthMatrix(priorMx);
      console.log(`🔍 前月セル取得: ${Object.keys(priorMx).length}件`);
      
  
      // シフトカウント更新
      updateShiftCounts(matrix, registeredEmployeeIds, monthDates);
      
     
  
    } catch (err) {
      console.error("❌ 読み込みエラー:", err);
      alert("データの読み込みに失敗しました: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  // 希望データを統合してstateに設定
  useEffect(() => {
    const mergedHopes = mergeHopes(originalHopes, adminHopes);
    setHopes(mergedHopes);
    
    // 🔥 詳細ログ
    console.log("🔍 希望データ統合完了:");
    console.log("  - originalHopes:", Object.keys(originalHopes).length, "件");
    console.log("  - adminHopes:", Object.keys(adminHopes).length, "件");
    console.log("  - 統合後hopes:", Object.keys(mergedHopes).length, "件");
    
    // 🔥 サンプルデータ表示
    if (Object.keys(mergedHopes).length > 0) {
      const sampleKey = Object.keys(mergedHopes)[0];
      
    }
    
    // 🔥 特定のスタッフ・日付の希望を確認
    const testKey = "222246_2026-03-13";
   
  }, [originalHopes, adminHopes]);

  const applyCustomShiftPatterns = (matrix, staffList, dates) => {
    staffList.forEach(staff => {
      if (staff.excludeFromAutoAssign && staff.customShiftPattern) {
        dates.forEach(date => {
          const dayOfWeek = dayjs(date).day();
          const dayName = ["日", "月", "火", "水", "木", "金", "土"][dayOfWeek];
          const customShift = staff.customShiftPattern[dayName];
          
          if (customShift) {
            matrix[`${staff.employeeId}_${date}`] = customShift;
          }
        });
      }
    });
  };

  useEffect(() => {
    if (currentOrganization?.id) {
      fetchData();
    }
  }, [currentMonth, selectedYear, currentOrganization?.id]);

  // 当月のオーバーライドを取得（モーダル外でも常時表示するため）
  useEffect(() => {
    const loadMonthlyOverrides = async () => {
      if (!currentOrganization?.id || !dates || dates.length === 0) {
        setMonthlyOverrides([]);
        return;
      }
      const first = dates[0];
      const last = dates[dates.length - 1];
      const { data, error } = await supabase
        .from('daily_required_overrides')
        .select('override_date, required_counts, note')
        .eq('organization_id', currentOrganization.id)
        .gte('override_date', first)
        .lte('override_date', last)
        .order('override_date', { ascending: true });
      if (error) {
        console.warn('オーバーライド取得失敗:', error);
        setMonthlyOverrides([]);
        return;
      }
      setMonthlyOverrides(data || []);
    };
    loadMonthlyOverrides();
    // モーダルが閉じた時にも再取得
  }, [currentOrganization?.id, dates, showDailyOverrideModal]);

  // shiftPatterns が後から到着した場合に updateShiftCounts を再計算
  //   （fetchData と fetchShiftOptions が独立しているため、
  //     パターン読込前に updateShiftCounts が走ると休暇設定が反映されない問題への対策）
  useEffect(() => {
    if (uniqueEmployeeIds.length === 0 || dates.length === 0) return;
    if (shiftPatterns.length === 0) return;
    updateShiftCounts(shiftMatrix, uniqueEmployeeIds, dates);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shiftPatterns]);

  // 年度累計集計のフェッチ
  //   年度 = 4月始まり翌3月終わり（日本の会計年度）
  //   - 表示月が 4月〜12月 なら、年度開始は selectedYear-04-01
  //   - 表示月が 1月〜3月 なら、年度開始は (selectedYear-1)-04-01
  //   当月分は shiftMatrix から動的加算するので、ここでは年度開始 〜 前月末 まで取得
  useEffect(() => {
    const fetchAnnualCounts = async () => {
      if (!currentOrganization?.id) return;
      const needAnnual = shiftPatterns.some(p => p.aggregationPeriod === 'annual');
      if (!needAnnual) {
        setAnnualHolidayCounts({});
        return;
      }
      try {
        const fiscalYear = currentMonth >= 4 ? selectedYear : selectedYear - 1;
        const fiscalYearStart = `${fiscalYear}-04-01`;
        const currentMonthStart = `${selectedYear}-${String(currentMonth).padStart(2, '0')}-01`;

        // 当月が年度開始月（4月）と同じなら過去分なし
        if (currentMonthStart === fiscalYearStart) {
          console.log('📅 年度累計: 当月が年度開始月のため過去分なし');
          setAnnualHolidayCounts({});
          return;
        }
        const priorMonthEnd = dayjs(currentMonthStart).subtract(1, 'day').format('YYYY-MM-DD');
        const { data, error } = await supabase
          .from('monthly_shifts')
          .select('employee_id, shift_type')
          .eq('organization_id', currentOrganization.id)
          .gte('shift_date', fiscalYearStart)
          .lte('shift_date', priorMonthEnd);
        if (error) throw error;
        const map = {};
        (data || []).forEach(row => {
          const t = row.shift_type;
          if (!t) return;
          const empId = String(row.employee_id);
          if (!map[empId]) map[empId] = {};
          map[empId][t] = (map[empId][t] || 0) + 1;
        });
        setAnnualHolidayCounts(map);
        console.log('📅 年度累計集計取得:', {
          fiscalYearStart,
          priorMonthEnd,
          rowsFetched: (data || []).length,
          staffCount: Object.keys(map).length,
        });
      } catch (e) {
        console.error('❌ 年度累計集計取得エラー:', e);
        setAnnualHolidayCounts({});
      }
    };
    fetchAnnualCounts();
  }, [currentMonth, selectedYear, currentOrganization?.id, shiftPatterns]);

  // useEffectを追加（fetchDataの後あたり）
useEffect(() => {
  const handleEscape = (e) => {
    if (e.key === 'Escape' && isFocusMode) {
      setIsFocusMode(false);
    }
  };
  
  window.addEventListener('keydown', handleEscape);
  return () => window.removeEventListener('keydown', handleEscape);
}, [isFocusMode]);

  // 🔥 一時的に無効化
/*
  useEffect(() => {
    if (process.env.NODE_ENV === 'development' && staffList.length > 0) {
      console.log("年間履歴確認中（デバッグモード）...");
      fetchYearlyShiftHistory(dayjs().year(), staffList)
        .then(history => {
          console.log("年間シフト履歴:", history);
        })
        .catch(error => {
          console.error("年間履歴取得エラー:", error);
        });
    }
  }, [staffList]);
*/

  useEffect(() => {
    const fetchSkills = async () => {
      console.log("スキルデータ取得中...");
      try {
        const organizationId = currentOrganization?.id;
        
        // ページネーションで全件取得
        let allRecords = [];
        let from = 0;
        const pageSize = 1000; // Supabaseの推奨サイズ
        
        while (true) {
          let query = supabase
            .from('skill_records')
            .select('*')
            .range(from, from + pageSize - 1);
          
          if (organizationId) {
            query = query.eq('organization_id', organizationId);
          }
          
          const { data, error } = await query;
          
          if (error) {
            console.error("❌ スキルデータ取得エラー:", error);
            throw error;
          }
          
          if (!data || data.length === 0) break;
          
          allRecords = allRecords.concat(data);
          console.log(`📄 ${from + 1}～${from + data.length}件取得（累計: ${allRecords.length}件）`);
          
          from += pageSize;
          
          // 取得データがpageSizeより少なければ最後のページ
          if (data.length < pageSize) break;
        }
        
        console.log(`✅ スキルレコード取得完了: ${allRecords.length}件`);
        
        // 社員ごとに集計
        const skillSummary = {};
        
        allRecords.forEach(record => {
          const userId = record.user_id;
          
          if (!skillSummary[userId]) {
            skillSummary[userId] = {
              combatPower: 0,
              departments: {},
              procedures: {}
            };
          }
          
          // ここで集計処理
          // （既存の集計ロジックをそのまま使用）
        });
        
        const uniqueUsers = Object.keys(skillSummary).length;
        console.log(`✅ スキルデータ集計完了: ${uniqueUsers}人`);
        
        // 既存のステートに保存
        setSkillData(skillSummary);
        
      } catch (error) {
        console.error("スキルデータ取得エラー:", error);
        setSkillData({});
      }
    };
    fetchSkills();
  }, []);

  // 管理者希望の保存（最適化版）
  const handleSaveAdminHopes = async (exitEditMode = false) => {
    try {
      const year = selectedYear;
      const title = `${year}年${currentMonth}月`;
      
      
      
      if (!currentOrganization?.id) {
        console.error('組織IDが取得できません');
        return;
      }
      const organizationId = currentOrganization.id;
      
      const recordsToUpsert = Object.entries(adminHopes).map(([key, selection]) => {
        const [employee_id, shift_date] = key.split('_');
        return {
          organization_id: organizationId,
          employee_id,
          shift_date,
          selection,
          edited_by_admin_id: null,
          edit_reason: 'Edited by admin',
          updated_at: new Date().toISOString()
        };
      });
      
      
      
      const { error } = await supabase
        .from('admin_shift_overrides')
        .upsert(recordsToUpsert, { 
          onConflict: 'organization_id,employee_id,shift_date' 
        });
      
      if (error) {
        console.error("❌ Supabase保存エラー:", error);
        throw error;
      }
      
      
      
      setSavedAdminHopes({ ...adminHopes });
      
      // 保存成功通知
      const notification = document.createElement('div');
      notification.innerHTML = `
        <div style="
          position: fixed; 
          top: 80px; 
          left: 50%; 
          transform: translateX(-50%); 
          background: linear-gradient(135deg, #16a34a 0%, #15803d 100%); 
          color: white; 
          padding: 12px 24px; 
          border-radius: 25px; 
          z-index: 10000;
          font-weight: 600;
          box-shadow: 0 8px 25px rgba(22, 163, 74, 0.4);
          animation: saveNotification 3s ease-in-out forwards;
        ">
          ✅ 希望データを保存しました！ (${Object.keys(adminHopes).length}件)
        </div>
        <style>
          @keyframes saveNotification {
            0% { opacity: 0; transform: translateX(-50%) translateY(-20px); }
            15%, 85% { opacity: 1; transform: translateX(-50%) translateY(0); }
            100% { opacity: 0; transform: translateX(-50%) translateY(-20px); }
          }
        </style>
      `;
      document.body.appendChild(notification);
      
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 3000);
      
      const newMergedHopes = mergeHopes(originalHopes, adminHopes);
      setHopes(newMergedHopes);
      
      
      
    } catch (error) {
      console.error("❌ 管理者希望データ保存エラー:", error);
      
      const errorNotification = document.createElement('div');
      errorNotification.innerHTML = `
        <div style="
          position: fixed; 
          top: 80px; 
          left: 50%; 
          transform: translateX(-50%); 
          background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%); 
          color: white; 
          padding: 12px 24px; 
          border-radius: 25px; 
          z-index: 10000;
          font-weight: 600;
          box-shadow: 0 8px 25px rgba(220, 38, 38, 0.4);
          animation: errorNotification 4s ease-in-out forwards;
        ">
          ❌ 保存に失敗しました: ${error.message}
        </div>
        <style>
          @keyframes errorNotification {
            0% { opacity: 0; transform: translateX(-50%) translateY(-20px); }
            15%, 85% { opacity: 1; transform: translateX(-50%) translateY(0); }
            100% { opacity: 0; transform: translateX(-50%) translateY(-20px); }
          }
        </style>
      `;
      document.body.appendChild(errorNotification);
      
      setTimeout(() => {
        if (errorNotification.parentNode) {
          errorNotification.parentNode.removeChild(errorNotification);
        }
      }, 4000);
    }
  };

  // 変更があるかどうかを判定するヘルパー関数（修正版）
  const hasUnsavedChanges = useMemo(() => {
    // adminHopesとsavedAdminHopesの差分をチェック
    const currentKeys = Object.keys(adminHopes);
    const savedKeys = Object.keys(savedAdminHopes);
    
    // キー数が違う場合は変更あり
    if (currentKeys.length !== savedKeys.length) {
      return true;
    }
    
    // 各キーの値をチェック
    for (const key of currentKeys) {
      if (adminHopes[key] !== savedAdminHopes[key]) {
        return true;
      }
    }
    
    // savedAdminHopesにあってadminHopesにないキーがあるかチェック
    for (const key of savedKeys) {
      if (!(key in adminHopes)) {
        return true;
      }
    }
    
    return false;
  }, [adminHopes, savedAdminHopes]);

  // 順序編集モードの変更検知
const hasOrderChanges = useMemo(() => {
  if (customStaffOrder.length !== savedStaffOrder.length) {
    return true;
  }
  
  return customStaffOrder.some((empId, index) => empId !== savedStaffOrder[index]);
}, [customStaffOrder, savedStaffOrder]);

  // 未保存変更の件数を計算
  const unsavedChangeCount = useMemo(() => {
    if (!hasUnsavedChanges) return 0;
    
    const changes = new Set();
    
    // 新規追加・変更されたキー
    Object.keys(adminHopes).forEach(key => {
      if (adminHopes[key] !== savedAdminHopes[key]) {
        changes.add(key);
      }
    });
    
    // 削除されたキー
    Object.keys(savedAdminHopes).forEach(key => {
      if (!(key in adminHopes)) {
        changes.add(key);
      }
    });
    
    return changes.size;
  }, [adminHopes, savedAdminHopes, hasUnsavedChanges]);

  

  // 管理者希望の変更（即座保存版）
const handleAdminHopeChange = async (empId, date, value) => {
  const key = `${empId}_${date}`;
  const originalValue = originalHopes[key] || "";
  
  
  
  // State更新
  setAdminHopes(prev => {
    const newAdminHopes = { ...prev };
    
    if (value === originalValue) {
      // 元の個人提出希望と同じ場合は管理者設定を削除
      delete newAdminHopes[key];
      
    } else {
      // 元の希望と異なる場合は管理者設定として保存
      newAdminHopes[key] = value;
      
    }
    
    return newAdminHopes;
  });
  
  // 即座に保存
  await saveAdminHopeImmediately(empId, date, value, originalValue);
};

// 希望の即座保存関数
const saveAdminHopeImmediately = async (empId, date, value, originalValue) => {
  try {
    if (!currentOrganization?.id) {
      console.error('組織IDが取得できません');
      return;
    }
    const organizationId = currentOrganization.id;
    
    
    
    if (value === originalValue) {
      // 元の希望と同じ場合は管理者設定を削除
      const { error } = await supabase
        .from('admin_shift_overrides')
        .delete()
        .eq('organization_id', organizationId)
        .eq('employee_id', empId)
        .eq('shift_date', date);
      
      if (error) {
        console.error("❌ 希望削除エラー:", error);
        throw error;
      }
      
      
    } else {
      // 新しい値で保存
      const recordToSave = {
        organization_id: organizationId,
        employee_id: empId,
        shift_date: date,
        selection: value,
        edited_by_admin_id: null,
        edit_reason: 'Edited by admin',
        updated_at: new Date().toISOString()
      };
      
      const { error } = await supabase
        .from('admin_shift_overrides')
        .upsert(recordToSave, { 
          onConflict: 'organization_id,employee_id,shift_date' 
        });
      
      if (error) {
        console.error("❌ 希望保存エラー:", error);
        throw error;
      }
      
     
    }
    
    // 統合希望データを更新
    const newMergedHopes = mergeHopes(originalHopes, adminHopes);
    setHopes(newMergedHopes);
    setSavedAdminHopes({ ...adminHopes });
    
  } catch (error) {
    console.error("❌ 希望自動保存エラー:", error);
    
    // エラー通知
    const notification = document.createElement('div');
    notification.innerHTML = `
      <div style="
        position: fixed; 
        top: 80px; 
        right: 20px; 
        background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%); 
        color: white; 
        padding: 12px 20px; 
        border-radius: 12px; 
        z-index: 10000;
        font-size: 14px;
        font-weight: 600;
        box-shadow: 0 4px 15px rgba(220, 38, 38, 0.4);
      ">
        ❌ 希望保存失敗: ${error.message}
      </div>
    `;
    document.body.appendChild(notification);
    
    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification);
      }
    }, 3000);
  }
};

  // スキルグループデータを取得
// スキルグループデータを取得
const fetchStaffGroups = async () => {
  try {
    if (!currentOrganization?.id) {
      console.error('組織IDが取得できません');
      return {};
    }
    
    // 🔥 Step 1: スタッフデータ取得（id → employee_id のマッピング）
    const { data: staffData, error: staffError } = await supabase
      .from('staff')
      .select('id, employee_id')
      .eq('organization_id', currentOrganization.id);
    
    if (staffError) {
      console.error("スタッフデータ取得エラー:", staffError);
      return {};
    }
    
    // id → employee_id と employee_id 自身集合を作成（両方向解決のため）
    const idToEmployeeId = {};
    const employeeIdSet = new Set();
    (staffData || []).forEach(staff => {
      if (staff.id) idToEmployeeId[String(staff.id)] = staff.employee_id;
      if (staff.employee_id) employeeIdSet.add(String(staff.employee_id));
    });

    console.log("✅ id→employee_idマップ作成:", Object.keys(idToEmployeeId).length, "件");

    // 🔥 Step 2: スキルグループ取得
    const { data: groups, error: groupError } = await supabase
      .from('skill_groups')
      .select('*')
      .eq('organization_id', currentOrganization.id);

    if (groupError) {
      console.error("スキルグループ取得エラー:", groupError);
      return {};
    }

    // 🔥 Step 3: employee_id → グループID配列のマップを作成
    // skill_groups.members は employee_id ベースが基本だが、旧データには staff.id (UUID) が
    // 入っているケースがある。両形式を許容して resolve する。
    const staffGroupMap = {};

    (groups || []).forEach(group => {
      (group.members || []).forEach(m => {
        const v = String(m);
        let employeeId = null;
        if (employeeIdSet.has(v)) {
          employeeId = v;                    // 既に employee_id
        } else if (idToEmployeeId[v]) {
          employeeId = idToEmployeeId[v];    // UUID → employee_id 変換
        }

        if (employeeId) {
          if (!staffGroupMap[employeeId]) {
            staffGroupMap[employeeId] = [];
          }
          staffGroupMap[employeeId].push(group.id);
        }
      });
    });
    
    // 🔥 デバッグ
    console.log("\n🔍 staffGroupMap のキーサンプル:");
    const sampleKeys = Object.keys(staffGroupMap).slice(0, 10);
    console.log("  キー:", sampleKeys);
    
    console.log(`✅ スキルグループマップ作成: ${Object.keys(staffGroupMap).length}人分`);
    return staffGroupMap;
  } catch (error) {
    console.error("スキルグループ取得エラー:", error);
    return {};
  }
};

  // 🔥 【修正】自動割り当て処理のエラーハンドリング強化
  const handleAutoAssignment = async (jobTypeId = null) => {
    setIsLoading(true);
    setProgressPercent(0);
    setLastJobTypeFilter(jobTypeId);

    // 職種別ボタンが押された場合、テーブル表示もその職種に絞る
    if (jobTypeId) setSelectedJobType(jobTypeId);

    const debugMode = window.confirm("詳細なデバッグ情報を表示しますか？");
    
    try {
      console.log("=== 自動割り当て開始前のデータ検証 ===");
      
      // 🔥 【修正】staffListの型とデータ構造を厳密にチェック
      let validStaffList = [];
      
      if (!staffList) {
        const errorMsg = "スタッフリストが取得できていません（null/undefined）。データを再読み込みしてから実行してください。";
        console.error("❌ " + errorMsg);
        alert("❌ " + errorMsg);
        return;
      }
      
      if (Array.isArray(staffList)) {
        validStaffList = staffList;
        console.log("✅ staffListは配列です");
      } else if (typeof staffList === 'object') {
        // オブジェクトの場合は配列に変換を試みる
        try {
          validStaffList = Object.values(staffList);
          console.log("⚠️ staffListがオブジェクトだったため配列に変換しました", {
            originalType: typeof staffList,
            convertedLength: validStaffList.length
          });
        } catch (conversionError) {
          console.error("❌ staffListの配列変換に失敗:", conversionError);
          const errorMsg = "スタッフリストのデータ形式が不正です。データを再読み込みしてから実行してください。";
          alert("❌ " + errorMsg);
          return;
        }
      } else {
        const errorMsg = `スタッフリストの型が不正です（${typeof staffList}）。データを再読み込みしてから実行してください。`;
        console.error("❌ " + errorMsg, { staffList });
        alert("❌ " + errorMsg);
        return;
      }
      
      if (validStaffList.length === 0) {
        const errorMsg = "スタッフデータが空です。スタッフを登録してから実行してください。";
        console.error("❌ " + errorMsg);
        alert("❌ " + errorMsg);
        return;
      }
      
      // 🔥 【修正】スタッフデータの構造検証
      const invalidStaff = validStaffList.filter(staff => 
        !staff || !staff.employeeId || typeof staff.employeeId !== 'string'
      );
      
      if (invalidStaff.length > 0) {
        console.error("❌ 不正なスタッフデータが含まれています:", invalidStaff);
        const errorMsg = `不正なスタッフデータが${invalidStaff.length}件含まれています。データを確認してください。`;
        alert("❌ " + errorMsg);
        return;
      }
      
      if (!dates || !Array.isArray(dates) || dates.length === 0) {
        const errorMsg = "日付データが取得できていません。データを再読み込みしてから実行してください。";
        console.error("❌ " + errorMsg, { dates: typeof dates, length: dates?.length });
        alert("❌ " + errorMsg);
        return;
      }
      
      if (!hopes || typeof hopes !== 'object') {
        console.warn("⚠️ 希望データが取得できていません。空のデータで実行します。", { hopes: typeof hopes });
      }

      const year = selectedYear;
      const month = currentMonth;
      
      console.log("✅ データ検証完了:");
      console.log(`  - スタッフ数: ${validStaffList.length}人`);
      console.log(`  - 有効スタッフID: ${validStaffList.map(s => s.employeeId).join(', ')}`);
      console.log(`  - 日付数: ${dates.length}日`);
      console.log(`  - 希望データ数: ${Object.keys(hopes || {}).length}件`);
      console.log(`  - 対象年月: ${year}年${month}月`);
      
      // シフトパターンの確認と再取得
      let validShiftPatterns = shiftPatterns;
      if (!validShiftPatterns || validShiftPatterns.length === 0) {
        console.log("⚠️ シフトパターンが未取得、再取得を試みます");
        try {
          // ⚠️ Firebase削除: Supabaseに移行済みのため、この機能は一時的に無効化
          // const patternsSnap = await getDocs(collection(db, "shiftPatterns"));
          // validShiftPatterns = patternsSnap.docs.map(doc => ({ 
          //   id: doc.id, 
          //   ...doc.data(),
          //   flexibilityType: doc.data().flexibilityType || "flexible",
          //   minRequired: doc.data().minRequired || 0,
          //   forceAssign: doc.data().forceAssign || false
          // }));
          // setShiftPatterns(validShiftPatterns);
          console.log("⚠️ シフトパターン取得機能は一時的に無効化されています");
          validShiftPatterns = validShiftPatterns || [];
        } catch (patternError) {
          console.error("❌ シフトパターン取得エラー:", patternError);
          alert("❌ シフトパターンの取得に失敗しました。管理者に連絡してください。");
          return;
        }
      } else {
        console.log(`✅ シフトパターン: ${validShiftPatterns.length}件`);
      }
      
      // スキルサマリーの取得
      console.log("スキルサマリー取得中...");
      let skillSummaries = {};
try {
  // ⚠️ Firebase削除: Supabaseに移行済みのため、この機能は一時的に無効化
  // const skillSummarySnap = await getDocs(collection(db, "staffSkillSummary"));
  // skillSummarySnap.docs.forEach(doc => {
  //   skillSummaries[doc.id] = doc.data();
  // });
  console.log("⚠️ スキルサマリー取得機能は一時的に無効化されています");
  skillSummaries = {};
} catch (skillError) {
  console.warn("⚠️ スキルサマリー取得エラー（処理は継続）:", skillError);
  skillSummaries = {};
}
      
      // 進捗コールバック
      const onProgress = (percent) => {
        setProgressPercent(percent);
        console.log(`🔄 進捗: ${percent}%`);
      };
      
      // 🔥 スキルグループデータを取得
      const staffGroupMap = await fetchStaffGroups();

      // 🔥 デバッグログ追加
console.log("\n🔍 スキルグループマップ確認:");
console.log("  - 取得件数:", Object.keys(staffGroupMap).length, "人");
if (Object.keys(staffGroupMap).length > 0) {
  const sample = Object.entries(staffGroupMap).slice(0, 5);
  console.log("  - サンプル:");
  sample.forEach(([empId, groups]) => {
    console.log(`    ${empId}: [${groups.join(', ')}]`);
  });
}

// 🔥 パターンとの照合確認
console.log("\n🔍 targetGroup設定確認:");
validShiftPatterns.forEach(p => {
  if (p.targetGroup) {
    console.log(`  ${p.name}: targetGroup="${p.targetGroup}"`);
    
    // このグループに属するスタッフを確認
    const eligibleStaff = Object.entries(staffGroupMap)
      .filter(([empId, groups]) => groups.includes(p.targetGroup))
      .map(([empId]) => empId);
    
    console.log(`    → 該当スタッフ: ${eligibleStaff.length}人`, eligibleStaff.slice(0, 3));
  }
});

      console.log("🚀 自動割り当て実行中...");
      console.log("使用データ:");
      console.log("  - year:", year);
      console.log("  - month:", month);
      console.log("  - validStaffList.length:", validStaffList.length);
      console.log("  - validStaffList[0]:", validStaffList[0]);
      console.log("  - hopes (統合済み):", Object.keys(hopes || {}).length, "件");
      console.log("  - originalHopes:", Object.keys(originalHopes || {}).length, "件");
      console.log("  - adminHopes:", Object.keys(adminHopes || {}).length, "件");
      console.log("  - validShiftPatterns.length:", validShiftPatterns.length);
      console.log("  - holidays.length:", holidays.length);
      console.log("  - dates.length:", dates.length);
      console.log("  - settings:", settings);
      
      // 🔥 【修正】検証済みの配列データを使用し、統合された希望データを渡す
      const result = await runFullAutoAssignment(
        year,
        month,
        validStaffList, // 🔥 検証・変換済みのstaffListを渡す
        hopes || {}, // 🔥 統合された希望データを使用（nullチェック）
        validShiftPatterns,
        holidays,
        dates,
        settings,
        onProgress,
        {
          organizationId: currentOrganization?.id,
          adminHopes: adminHopes,
          staffGroups: staffGroupMap,
          jobTypeFilter: jobTypeId, // 職種フィルタ（null = 全職種）
          debugMode
        }
      );
      
      console.log("✅ 自動割り当て成功！", result);

     // 🔥 デバッグログ追加
console.log("\n🔍 result.matrix のサンプル10件:");
const sample = Object.entries(result.matrix).slice(0, 10);
sample.forEach(([key, value]) => {
  console.log(`  ${key}: "${value}" (型: ${typeof value})`);
});

console.log("\n🔍 夜勤が含まれているかチェック:");
const nightShifts = Object.entries(result.matrix).filter(([key, value]) => 
  value && (value.includes('[/') || value.includes('ｵC') || value.includes('ｵﾛ'))
);
console.log(`  夜勤・オンコール件数: ${nightShifts.length}件`);
nightShifts.slice(0, 5).forEach(([key, value]) => {
  console.log(`    ${key}: ${value}`);
});
      
      // 職種別実行時は、他職種のセルを保持するため既存マトリクスにマージ
      // 全職種実行時も result が全員分のセルを持つのでマージで同じ結果になる（安全）
      const mergedMatrix = { ...shiftMatrix, ...result.matrix };
      setShiftMatrix(mergedMatrix);
      console.log(
        `✅ シフトマトリックス更新完了 (jobTypeFilter=${jobTypeId || 'なし'}, 結果セル ${Object.keys(result.matrix).length} 件をマージ)`
      );

      updateShiftCounts(mergedMatrix, uniqueEmployeeIds, dates);
      console.log("✅ シフトカウント更新完了");
      
      // 🔥 【修正】conflicts構造の検証とデバッグ
      let validConflicts = { off: {}, night: {} };
      
      if (result.conflicts) {
        if (typeof result.conflicts === 'object' && 
            result.conflicts.off !== undefined && 
            result.conflicts.night !== undefined) {
          validConflicts = result.conflicts;
          console.log("✅ 有効なconflicts構造を確認:", validConflicts);
        } else {
          console.warn("⚠️ conflicts構造が不正です:", result.conflicts);
        }
      } else if (result.conflictInfo) {
        // 場合によってはconflictInfoとして返される可能性
        if (typeof result.conflictInfo === 'object' && 
            result.conflictInfo.off !== undefined && 
            result.conflictInfo.night !== undefined) {
          validConflicts = result.conflictInfo;
          console.log("✅ conflictInfoから有効な構造を確認:", validConflicts);
        } else {
          console.warn("⚠️ conflictInfo構造が不正です:", result.conflictInfo);
        }
      }

      // 🔥 【修正】モーダルに渡すデータを整理（null除去版）
console.log("\n🔍 result.matrix の null をチェック:");
const nullCount = Object.values(result.matrix).filter(v => v === null).length;
console.log(`  - null の件数: ${nullCount}件`);

// 🔥 null を空文字列に変換
const cleanedMatrix = {};
Object.entries(result.matrix).forEach(([key, value]) => {
  cleanedMatrix[key] = value === null ? "" : value;
});

console.log("✅ null → 空文字列 変換完了");
      
      // 🔥 【修正】モーダルに渡すデータを整理
      setAutoAssignmentResult({
        ...result,
        matrix: cleanedMatrix,
        conflicts: validConflicts,
        // 🔥 【追加】希望データの詳細情報
        hopeDetails: {
          merged: hopes,
          original: originalHopes,
          admin: adminHopes,
          counts: {
            merged: Object.keys(hopes || {}).length,
            original: Object.keys(originalHopes || {}).length,
            admin: Object.keys(adminHopes || {}).length
          }
        }
      });
      
      setShowAssignmentModal(true);
      console.log("✅ 結果表示モーダル表示");

      return;
      
    } catch (err) {
      console.error("❌ 自動割り当てエラー:", err);
      
      // エラーの詳細情報を収集
      const errorDetails = {
        message: err.message,
        stack: err.stack,
        staffListType: typeof staffList,
        staffListLength: Array.isArray(staffList) ? staffList.length : 'not array',
        datesType: typeof dates,
        datesLength: Array.isArray(dates) ? dates.length : 'not array',
        hopesType: typeof hopes,
        hopesLength: hopes ? Object.keys(hopes).length : 'null/undefined',
        originalHopesLength: originalHopes ? Object.keys(originalHopes).length : 'null/undefined',
        adminHopesLength: adminHopes ? Object.keys(adminHopes).length : 'null/undefined'
      };
      
      console.error("エラー詳細情報:", errorDetails);
      
      let userMessage = `自動割り当てに失敗しました: ${err.message}\n\n`;
      userMessage += "詳細情報:\n";
      userMessage += `- スタッフリスト: ${errorDetails.staffListType} (${errorDetails.staffListLength})\n`;
      userMessage += `- 日付データ: ${errorDetails.datesType} (${errorDetails.datesLength})\n`;
      userMessage += `- 統合希望データ: ${errorDetails.hopesType} (${errorDetails.hopesLength})\n`;
      userMessage += `- 個人希望データ: ${errorDetails.originalHopesLength}\n`;
      userMessage += `- 管理者希望データ: ${errorDetails.adminHopesLength}\n`;
      userMessage += "\nページをリロードしてから再試行してください。";
      
      alert(userMessage);
    } finally {
      setIsLoading(false);
      setProgressPercent(0);
    }
  };

  // 希望の表示用短縮ラベルを取得
const getHopeDisplayLabel = (hopeValue) => {
  if (!hopeValue) return "";
  const v = String(hopeValue).trim();

  // ① shift_patterns の request_group / requestGroupLabel / displayMark / id に一致するか確認
  const pattern = shiftPatterns.find(p =>
    p.requestGroup === v
    || p.requestGroup === v.toLowerCase()
    || p.requestGroupLabel === v
    || p.displayMark === v
    || p.id === v
  );
  if (pattern) {
    // 希望フォームでの記号があれば最優先、なければ表示名の先頭2文字
    if (pattern.requestDisplayMark) return pattern.requestDisplayMark;
    const label = pattern.requestGroupLabel || pattern.name || v;
    // 「希望」末尾が付いていればその直前2文字、それ以外は先頭2文字 + 希
    const base = label.replace(/希望$/, '');
    return `${base.substring(0, 2)}希`;
  }

  // ② レガシーのセマンティック種別（古い希望データ用）
  if (v === "off") return "休希";
  if (v === "night") return "夜希";
  if (v === "none" || v === "day") return "日希";

  return v; // 見つからない場合はそのまま返す
};

const handleSaveAssignmentChanges = async (updatedMatrix, resolutions) => {
  // _confirmedキーを除外
  const { _confirmed, ...cleanMatrix } = updatedMatrix;
  
  // 🔥 バグ修正: 職種別自動割り当て時、updatedMatrix はその職種分のみを含む。
  // 既存 shiftMatrix とマージして state を更新し、保存は touched セルだけに絞ることで
  // 他職種のシフトが NULL で上書きされてしまう問題を防ぐ。
  const mergedMatrix = { ...shiftMatrix, ...cleanMatrix };

  setShiftMatrix(mergedMatrix);
  updateShiftCounts(mergedMatrix, uniqueEmployeeIds, dates);

  // DBへ保存 (このモーダルで触ったセル = cleanMatrix のキーだけ upsert する)
  try {
    setSaving(true);
    const organizationId = currentOrganization.id;

    const recordsToUpsert = [];
    // cleanMatrix に含まれるセルだけ upsert する (職種別実行時は他職種のセルを維持)
    for (const [key, raw] of Object.entries(cleanMatrix)) {
      if (!key || typeof key !== 'string' || key.length < 11) continue;
      // key = `${empId}_${YYYY-MM-DD}` の末尾 10 文字が日付
      const date = key.slice(-10);
      const empId = key.slice(0, -11);
      if (!dates.includes(date)) continue;
      // Phase F: 空欄は NULL (未定) として保存
      const shiftValue = raw && String(raw).trim() !== "" ? raw : null;
      recordsToUpsert.push({
        organization_id: organizationId,
        employee_id: empId,
        shift_date: date,
        shift_type: shiftValue,
        updated_at: new Date().toISOString(),
      });
    }

    if (recordsToUpsert.length === 0) {
      alert("保存対象がありません");
      return;
    }

    const { error } = await supabase
      .from("monthly_shifts")
      .upsert(recordsToUpsert, {
        onConflict: "organization_id,employee_id,shift_date",
      });

    if (error) throw error;

    await writeClientAudit({
      organizationId,
      actionType: 'update',
      targetTable: 'monthly_shifts',
      targetSummary: `自動割り当て結果を保存: ${recordsToUpsert.length} セル`,
      changes: { cellCount: recordsToUpsert.length },
      success: true,
    });

    alert(`✅ ${recordsToUpsert.length} 件を保存しました (職種別実行時は他職種のシフトを維持します)`);
  } catch (err) {
    console.error("❌ 保存エラー:", err);
    await writeClientAudit({
      organizationId: currentOrganization?.id,
      actionType: 'update',
      targetTable: 'monthly_shifts',
      targetSummary: `自動割り当て結果の保存に失敗`,
      success: false,
      errorMessage: err.message,
    });
    alert("保存に失敗しました: " + err.message);
  } finally {
    setSaving(false);
  }
};

  // [その他の既存関数群はそのまま維持]
  const updateShiftCounts = (matrix, staffIds = uniqueEmployeeIds, dateList = dates) => {
    // 動的にシフトタイプを収集
    const shiftTypeCounts = {};
    const groupedShiftCounts = {}; // グループ別カウント
    
    // 基本シフトタイプの初期化（groupNameなしの場合のデフォルト）
    //   公休「休」は集計欄バッジを既定で ON（shift_patterns に該当パターンが無くても表示される）
    const baseShiftTypes = {
      '': { name: '日勤', color: '#0891b2', bg: '#e0f7fa', priority: 1 },
      '◯': { name: '日勤', color: '#0891b2', bg: '#e0f7fa', priority: 1 },
      '/': { name: '夜勤', color: '#be185d', bg: '#fce4ec', priority: 2 },
      '休': {
        name: '公休',
        color: '#64748b',
        bg: '#f1f5f9',
        priority: 99,
        showInAggregation: true,
        showAcquisitionRate: true,
      },
    };
    
    // shiftPatternsから動的シフトタイプを追加し、groupNameを設定
    //   ※ パターンが存在する mark についてはそのパターンの設定で上書き（明示 OFF を尊重）
    //     パターンが無い mark はハードコード fallback がそのまま残る（公休 '休' は既定 ON）
    shiftPatterns.forEach(pattern => {
      const mark = pattern.displayMark || pattern.id;
      if (mark) {
        baseShiftTypes[mark] = {
          name: pattern.name || mark,
          color: getShiftTypeColor(pattern.type || 'default'),
          bg: getShiftTypeBg(pattern.type || 'default'),
          priority: pattern.priority || 50,
          type: pattern.type || 'default',
          groupName: pattern.groupName || null,
          // 集計欄バッジ用
          showInAggregation: !!pattern.showInAggregation,
          holidayAnnualTotal: pattern.holidayAnnualTotal ?? null,
          holidayMonthlyLimit: pattern.holidayMonthlyLimit ?? null,
          holidayMonthlyLimitByMonth: pattern.holidayMonthlyLimitByMonth || null,
          aggregationPeriod: pattern.aggregationPeriod || 'monthly',
          showAcquisitionRate: !!pattern.showAcquisitionRate,
        };
      }
    });
    
    // 各日付の各シフトタイプの人数を計算
    dateList.forEach(date => {
      const dateCounts = {};
      const dateGroupCounts = {};
      
      // すべてのシフトタイプを0で初期化
      Object.keys(baseShiftTypes).forEach(shiftType => {
        dateCounts[shiftType] = 0;
      });
      
      staffIds.forEach(empId => {
        const value = matrix[`${empId}_${date}`];
        if (value !== undefined) {
          // 空文字は日勤として扱う
          const shiftType = value === '' ? '◯' : value;
          if (dateCounts[shiftType] !== undefined) {
            dateCounts[shiftType]++;
          } else {
            // 新しいシフトタイプが見つかった場合（パターン未登録）
            dateCounts[shiftType] = 1;
            if (!baseShiftTypes[shiftType]) {
              baseShiftTypes[shiftType] = {
                name: shiftType,
                color: '#6b7280',
                bg: '#f9fafb',
                priority: 60,
                groupName: null // 未登録パターンはグループなし
              };
            }
          }
          
          // グループ別カウント（groupNameがあるもののみ）
          const groupName = baseShiftTypes[shiftType]?.groupName;
          if (groupName) {
            dateGroupCounts[groupName] = (dateGroupCounts[groupName] || 0) + 1;
          } else {
            // groupNameがない場合は個別カウント（「その他」グループとして扱う）
            const individualGroupName = `個別_${shiftType}`;
            dateGroupCounts[individualGroupName] = (dateGroupCounts[individualGroupName] || 0) + 1;
          }
        }
      });
      
      shiftTypeCounts[date] = dateCounts;
      groupedShiftCounts[date] = dateGroupCounts;
    });
    
    // グループ情報を動的に作成
    const groupTypes = {};
    
    // まず、明示的にgroupNameが設定されているものを処理
    Object.entries(baseShiftTypes).forEach(([shiftType, typeInfo]) => {
      const groupName = typeInfo.groupName;
      if (groupName) {
        if (!groupTypes[groupName]) {
          groupTypes[groupName] = {
            name: groupName,
            color: typeInfo.color,
            bg: typeInfo.bg,
            priority: typeInfo.priority,
            type: typeInfo.type || 'default',
            shiftTypes: [shiftType],
            isGroup: true // 明示的なグループであることを示す
          };
        } else {
          groupTypes[groupName].shiftTypes.push(shiftType);
          // より優先度の高いシフトがあれば色を更新
          if (typeInfo.priority < groupTypes[groupName].priority) {
            groupTypes[groupName].color = typeInfo.color;
            groupTypes[groupName].bg = typeInfo.bg;
            groupTypes[groupName].priority = typeInfo.priority;
          }
        }
      } else {
        // groupNameがない場合は個別グループとして作成
        const individualGroupName = `個別_${shiftType}`;
        groupTypes[individualGroupName] = {
          name: typeInfo.name,
          color: typeInfo.color,
          bg: typeInfo.bg,
          priority: typeInfo.priority + 1000, // 個別項目は後ろに表示
          type: typeInfo.type || 'default',
          shiftTypes: [shiftType],
          isGroup: false // 個別パターンであることを示す
        };
      }
    });
    
    // 既存のstate更新（後方互換性のため）
    const dayCount = {};
    const nightCount = {};
    const onCallCount = {};
    const lateCCount = {};
    const oncallShiftCount = {};
    const freeCount = {};
    
    dateList.forEach(date => {
      const counts = shiftTypeCounts[date];
      dayCount[date] = (counts[''] || 0) + (counts['◯'] || 0);
      nightCount[date] = counts['/'] || 0;
      onCallCount[date] = counts['□'] || 0;
      lateCCount[date] = counts['ｵC'] || 0;
      oncallShiftCount[date] = counts['ｵﾛ'] || 0;
      freeCount[date] = counts['休'] || 0;
    });
    
    setDayShiftCount(dayCount);
    setNightShiftCount(nightCount);
    setOnCallDutyCount(onCallCount);
    setLateCShiftCount(lateCCount);
    setOnCallShiftCount(oncallShiftCount);
    setFreeShiftCount(freeCount);
    
    // 新しい動的シフトカウントもstateに保存（グループ情報も含める）
    setShiftTypeCounts({ 
      counts: shiftTypeCounts, 
      types: baseShiftTypes,
      groupCounts: groupedShiftCounts,
      groupTypes: groupTypes
    });
  };

  const calculateStaffShiftCounts = (matrix, staffIds, dates, patterns) => {
    // パラメータ検証
    if (!matrix || typeof matrix !== 'object') {
      console.error("❌ matrix が undefined:", matrix);
      return { staffCounts: {}, staffGroupCounts: {}, averages: {}, groupAverages: {}, totals: {}, groupTotals: {} };
    }
    
    if (!Array.isArray(staffIds) || staffIds.length === 0) {
      console.error("❌ staffIds が無効:", staffIds);
      return { staffCounts: {}, staffGroupCounts: {}, averages: {}, groupAverages: {}, totals: {}, groupTotals: {} };
    }
    
    if (!Array.isArray(dates) || dates.length === 0) {
      console.error("❌ dates が無効:", dates);
      return { staffCounts: {}, staffGroupCounts: {}, averages: {}, groupAverages: {}, totals: {}, groupTotals: {} };
    }
    
    console.log("📊 カウント開始 - matrix:", Object.keys(matrix).length, "件");
    
    const staffCounts = {};
    const staffGroupCounts = {}; // グループ別のスタッフ集計
    const shiftTypeTotals = {};
    const groupTotals = {}; // グループ別合計
    
    staffIds.forEach(empId => {
      const counts = {};
      const groupCounts = {};
      let totalDays = 0;
      
      dates.forEach(date => {  // ← ここが dates（dateListではない）
        const shiftValue = matrix[`${empId}_${date}`] || '';
        const shiftType = shiftValue === '' ? '◯' : shiftValue;
        
        counts[shiftType] = (counts[shiftType] || 0) + 1;
        totalDays++;
        
        // 全体集計
        shiftTypeTotals[shiftType] = (shiftTypeTotals[shiftType] || 0) + 1;
        
        // グループ別集計（動的groupName対応）
        const typeInfo = shiftTypeCounts.types?.[shiftType];
        let groupName;
        
        if (typeInfo?.groupName) {
          groupName = typeInfo.groupName;
        } else {
          // groupNameがない場合は個別グループ名
          groupName = `個別_${shiftType}`;
        }
        
        groupCounts[groupName] = (groupCounts[groupName] || 0) + 1;
        groupTotals[groupName] = (groupTotals[groupName] || 0) + 1;
      });
      
      staffCounts[empId] = { counts, totalDays };
      staffGroupCounts[empId] = { groupCounts, totalDays };
    });
    
    // 平均値を計算
    const averages = {};
    const groupAverages = {};
    
    Object.keys(shiftTypeTotals).forEach(shiftType => {
      averages[shiftType] = shiftTypeTotals[shiftType] / staffIds.length;
    });
    
    Object.keys(groupTotals).forEach(groupName => {
      groupAverages[groupName] = groupTotals[groupName] / staffIds.length;
    });
    
    return { 
      staffCounts, 
      staffGroupCounts,
      averages, 
      groupAverages,
      totals: shiftTypeTotals,
      groupTotals
    };
  };

  // シフトタイプをソートする関数（動的groupName対応版）
  const getSortedShiftTypes = (shiftTypes, counts, sortMethod = 'priority', useGrouping = true) => {
    // デフォルトでグループ表示を使用（groupNameベース）
    if (useGrouping && shiftTypeCounts.groupTypes) {
      const groupEntries = Object.entries(shiftTypeCounts.groupTypes);
      
      // 使用されているグループのみフィルター
      const usedGroupEntries = groupEntries.filter(([groupName]) => {
        return dates.some(date => 
          shiftTypeCounts.groupCounts[date] && 
          shiftTypeCounts.groupCounts[date][groupName] > 0
        );
      });
      
      switch (sortMethod) {
        case 'priority':
          return usedGroupEntries.sort((a, b) => {
            const priorityA = a[1].priority || 50;
            const priorityB = b[1].priority || 50;
            if (priorityA !== priorityB) {
              return priorityA - priorityB;
            }
            // 明示的なグループを個別グループより優先
            if (a[1].isGroup !== b[1].isGroup) {
              return b[1].isGroup - a[1].isGroup;
            }
            return a[1].name.localeCompare(b[1].name, 'ja');
          });
          
        case 'frequency':
          return usedGroupEntries.sort((a, b) => {
            const totalA = dates.reduce((sum, date) => 
              sum + (shiftTypeCounts.groupCounts[date]?.[a[0]] || 0), 0);
            const totalB = dates.reduce((sum, date) => 
              sum + (shiftTypeCounts.groupCounts[date]?.[b[0]] || 0), 0);
            if (totalA !== totalB) {
              return totalB - totalA;
            }
            return (a[1].priority || 50) - (b[1].priority || 50);
          });
          
        case 'alphabetical':
          return usedGroupEntries.sort((a, b) => {
            return a[1].name.localeCompare(b[1].name, 'ja');
          });
          
        default:
          return usedGroupEntries;
      }
    }
    
    // 個別表示の場合（既存のロジック）
    const entries = Object.entries(shiftTypes || {});
    
    const usedEntries = entries.filter(([shiftType]) => {
      return dates.some(date => 
        counts[date] && counts[date][shiftType] > 0
      );
    });
    
    switch (sortMethod) {
      case 'priority':
        return usedEntries.sort((a, b) => {
          const priorityA = a[1].priority || 50;
          const priorityB = b[1].priority || 50;
          if (priorityA !== priorityB) {
            return priorityA - priorityB;
          }
          return a[1].name.localeCompare(b[1].name, 'ja');
        });
        
      case 'frequency':
        return usedEntries.sort((a, b) => {
          const totalA = dates.reduce((sum, date) => sum + (counts[date]?.[a[0]] || 0), 0);
          const totalB = dates.reduce((sum, date) => sum + (counts[date]?.[b[0]] || 0), 0);
          if (totalA !== totalB) {
            return totalB - totalA;
          }
          return (a[1].priority || 50) - (b[1].priority || 50);
        });
        
      case 'alphabetical':
        return usedEntries.sort((a, b) => {
          return a[1].name.localeCompare(b[1].name, 'ja');
        });
        
      case 'type':
        const typeOrder = { 'day': 1, 'night': 2, 'oncall': 3, 'late': 4, 'break': 5, 'default': 6 };
        return usedEntries.sort((a, b) => {
          const typeA = typeOrder[a[1].type || 'default'] || 6;
          const typeB = typeOrder[b[1].type || 'default'] || 6;
          if (typeA !== typeB) {
            return typeA - typeB;
          }
          return (a[1].priority || 50) - (b[1].priority || 50);
        });
        
      default:
        return usedEntries;
    }
  };

  // シフトタイプの色を取得するヘルパー関数
  const getShiftTypeColor = (type) => {
    const colorMap = {
      'night': '#be185d',
      'day': '#0891b2',
      'oncall': '#d97706',
      'late': '#16a34a',
      'break': '#64748b',
      'default': '#6b7280'
    };
    return colorMap[type] || colorMap.default;
  };

  const getShiftTypeBg = (type) => {
    const bgMap = {
      'night': '#fce4ec',
      'day': '#e0f7fa',
      'oncall': '#fef3c7',
      'late': '#dcfce7',
      'break': '#f1f5f9',
      'default': '#f9fafb'
    };
    return bgMap[type] || bgMap.default;
  };

  const getCurrentHopeColor = (key) => {
    const value = hopes[key] || "";
    const option = hopeOptions.find(opt => opt.value === value);
    return option?.color || '#9ca3af';
  };
  
  const getCurrentHopeLabel = (key) => {
    const value = hopes[key] || "";
    const option = hopeOptions.find(opt => opt.value === value);
    return option?.label || "-";
  };

  // 統計情報を計算
  const statistics = useMemo(() => {
    const totalStaff = uniqueEmployeeIds.length;
    const submittedCount = submittedStaffIds.size;
    const submissionRate = totalStaff > 0 ? (submittedCount / totalStaff * 100).toFixed(1) : 0;
    const excludedCount = excludedStaff.length;
    const adminHopeCount = Object.keys(adminHopes).length;

    return {
      totalStaff,
      submittedCount,
      submissionRate,
      excludedCount,
      unsubmittedCount: totalStaff - submittedCount,
      adminHopeCount
    };
  }, [uniqueEmployeeIds, submittedStaffIds, excludedStaff, adminHopes]);

  // [既存の関数群を維持]
  const handleSave = async () => {
    setSaving(true);
    try {
      console.log("✅ シフト保存開始");
      
      if (!currentOrganization?.id) {
        alert("組織が選択されていません");
        setSaving(false);
        return;
      }
  
      const year = selectedYear;
      const organizationId = currentOrganization.id;
      
      console.log(`📋 Supabaseに保存: organization_id=${organizationId}, year=${year}, month=${currentMonth}`);
      
      // 🔥 保存するデータを準備
      const recordsToUpsert = [];
      
      uniqueEmployeeIds.forEach((empId) => {
        dates.forEach((date) => {
          const key = `${empId}_${date}`;
          // Phase F: 空欄は NULL（未定）。日勤として扱うには明示的にマークを入れる必要あり。
          const raw = shiftMatrix[key];
          const shiftValue = raw && String(raw).trim() !== "" ? raw : null;

          recordsToUpsert.push({
            organization_id: organizationId,
            employee_id: empId,
            shift_date: date,
            shift_type: shiftValue,
            updated_at: new Date().toISOString()
          });
        });
      });
  
      console.log(`📤 Supabaseに保存中: ${recordsToUpsert.length}件`);
  
      // 🔥 Supabaseのmonthly_shiftsテーブルにupsert
      const { error } = await supabase
        .from('monthly_shifts')
        .upsert(recordsToUpsert, { 
          onConflict: 'organization_id,employee_id,shift_date' 
        });
  
      if (error) {
        console.error("❌ Supabase保存エラー:", error);
        throw error;
      }
  
      console.log("✅ Supabase保存完了");
      await writeClientAudit({
        organizationId,
        actionType: 'update',
        targetTable: 'monthly_shifts',
        targetSummary: `シフト全体保存: ${selectedYear}年${currentMonth}月 (${recordsToUpsert.length} セル)`,
        changes: { year: selectedYear, month: currentMonth, cellCount: recordsToUpsert.length },
        success: true,
      });
      alert("✅ 保存完了！");

      // データ再読み込み
      fetchData();

    } catch (err) {
      console.error("❌ 保存エラー:", err);
      await writeClientAudit({
        organizationId: currentOrganization?.id,
        actionType: 'update',
        targetTable: 'monthly_shifts',
        targetSummary: `シフト全体保存失敗: ${selectedYear}年${currentMonth}月`,
        success: false,
        errorMessage: err.message,
      });
      alert("保存に失敗しました: " + err.message);
    } finally {
      setSaving(false);
    }
  };

  // ===========================================================================
  // シフト公開 / 下書き戻し
  //   shift_publications に (org, year, month) 行がある = 公開済み
  //   スタッフ画面 (StaffHome / CalendarPage) はこの行が無い月のシフトを表示しない
  // ===========================================================================
  const fetchPublishStatus = useCallback(async () => {
    if (!currentOrganization?.id) return;
    try {
      const { data } = await supabase
        .from('shift_publications')
        .select('published_at')
        .eq('organization_id', currentOrganization.id)
        .eq('year', selectedYear)
        .eq('month', currentMonth)
        .maybeSingle();
      setIsPublished(!!data);
    } catch (e) {
      console.warn('shift_publications 取得失敗:', e.message);
    }
  }, [currentOrganization?.id, selectedYear, currentMonth]);

  useEffect(() => {
    fetchPublishStatus();
  }, [fetchPublishStatus]);

  const handlePublishShift = async () => {
    if (!currentOrganization?.id) return;
    const monthLabel = `${selectedYear}年${currentMonth}月`;
    if (!window.confirm(
      `${monthLabel} のシフトを公開しますか?\n\n` +
      `公開後はスタッフの画面 (ホーム / カレンダー) にこの月のシフトが表示されます。\n\n` +
      `まだ編集中の場合はキャンセルしてください。`
    )) return;
    setPublishing(true);
    try {
      const payload = {
        organization_id: currentOrganization.id,
        year: selectedYear,
        month: currentMonth,
        published_at: new Date().toISOString(),
      };
      const { error } = await supabase
        .from('shift_publications')
        .upsert(payload, { onConflict: 'organization_id,year,month' });
      if (error) throw error;
      await writeClientAudit({
        organizationId: currentOrganization.id,
        actionType: 'create',
        targetTable: 'shift_publications',
        targetSummary: `シフト公開: ${monthLabel}`,
        changes: { year: selectedYear, month: currentMonth },
        success: true,
      });
      setIsPublished(true);
      alert(`✅ ${monthLabel} のシフトを公開しました`);
    } catch (e) {
      console.error('公開失敗:', e);
      await writeClientAudit({
        organizationId: currentOrganization?.id,
        actionType: 'create',
        targetTable: 'shift_publications',
        targetSummary: `シフト公開失敗: ${monthLabel}`,
        success: false,
        errorMessage: e.message,
      });
      alert('公開に失敗しました: ' + e.message);
    } finally {
      setPublishing(false);
    }
  };

  const handleUnpublishShift = async () => {
    if (!currentOrganization?.id) return;
    const monthLabel = `${selectedYear}年${currentMonth}月`;
    if (!window.confirm(
      `${monthLabel} のシフトを下書き状態に戻しますか?\n\n` +
      `スタッフの画面には再び表示されなくなります。`
    )) return;
    setPublishing(true);
    try {
      const { error } = await supabase
        .from('shift_publications')
        .delete()
        .eq('organization_id', currentOrganization.id)
        .eq('year', selectedYear)
        .eq('month', currentMonth);
      if (error) throw error;
      await writeClientAudit({
        organizationId: currentOrganization.id,
        actionType: 'delete',
        targetTable: 'shift_publications',
        targetSummary: `シフト公開取消 (下書きに戻し): ${monthLabel}`,
        changes: { year: selectedYear, month: currentMonth },
        success: true,
      });
      setIsPublished(false);
      alert(`${monthLabel} のシフトを下書きに戻しました`);
    } catch (e) {
      console.error('下書き戻し失敗:', e);
      await writeClientAudit({
        organizationId: currentOrganization?.id,
        actionType: 'delete',
        targetTable: 'shift_publications',
        targetSummary: `シフト公開取消失敗: ${monthLabel}`,
        success: false,
        errorMessage: e.message,
      });
      alert('下書きに戻せませんでした: ' + e.message);
    } finally {
      setPublishing(false);
    }
  };

  const handleCSVDownload = () => {
    let csv = ["社員番号", "氏名", ...dates].join(",") + "\n";
    uniqueEmployeeIds.forEach((empId) => {
      const s = staffList.find(s => s.employeeId === empId);
      const name = s ? `${s.lastName} ${s.firstName}` : empId;
      const row = [empId, name];
      dates.forEach((date) => {
        const value = shiftMatrix[`${empId}_${date}`];
        // ✅ 空文字は日勤として出力
        row.push(value === "" || value === undefined ? "◯" : value);
      });
      csv += row.join(",") + "\n";
    });
  
    // ✅ Windows対応：BOM付きUTF-8 + CRLF改行
    const bom = '\uFEFF';
    const csvWithCRLF = csv.replace(/\n/g, '\r\n');
    saveAs(
      new Blob([bom + csvWithCRLF], { type: "text/csv;charset=utf-8;" }),
      `${selectedYear}-${currentMonth}_shift.csv`
    );
  };

  const handleHopeCSVDownload = () => {
    let csv = ["社員番号", "氏名", ...dates].join(",") + "\n";
    uniqueEmployeeIds.forEach((empId) => {
      const s = staffList.find(s => s.employeeId === empId);
      const name = s ? `${s.lastName} ${s.firstName}` : empId;
      const row = [empId, name];
      dates.forEach((date) => {
        const key = `${empId}_${date}`;
        const hopeValue = hopes[key] || "";
        // ラベルに変換して出力
        const option = hopeOptions.find(opt => opt.value === hopeValue);
        const label = option?.fullLabel || option?.label || (hopeValue === "" ? "未設定" : hopeValue);
        row.push(label);
      });
      csv += row.join(",") + "\n";
    });
  
    const bom = '\uFEFF';
    const csvWithCRLF = csv.replace(/\n/g, '\r\n');
    saveAs(
      new Blob([bom + csvWithCRLF], { type: "text/csv;charset=utf-8;" }),
      `${selectedYear}-${currentMonth}_hopes.csv`
    );
  };

  // 催促: アプリ内通知 (staff_notifications) として送信。 Header のベル (InstructionNotificationBell)
  // やホーム画面に表示される。 メール送信はしない。
  const handleSendReminders = async () => {
    if (!currentOrganization?.id) {
      alert('組織情報を取得できません');
      return;
    }
    if (!unsubmitted || unsubmitted.length === 0) {
      alert('未提出のスタッフはいません');
      return;
    }
    const monthLabel = `${selectedYear}年${currentMonth}月`;
    const first = window.confirm(
      `未提出の ${unsubmitted.length} 名にアプリ内で提出催促の通知を送信します。\n\n対象月: ${monthLabel}\n\nよろしいですか？`
    );
    if (!first) return;
    // ダブル確認
    const second = window.confirm(
      `最終確認: ${unsubmitted.length} 名に催促通知を送ります。 本当に送信しますか？`
    );
    if (!second) return;

    try {
      const rows = [];
      const skipped = [];
      for (const empId of unsubmitted) {
        const staff = staffList.find((s) => s.employeeId === empId);
        if (!staff?.id) {
          skipped.push(`${empId}: スタッフ ID 不明`);
          continue;
        }
        rows.push({
          organization_id: currentOrganization.id,
          recipient_staff_id: staff.id,
          type: 'shift_request_reminder',
          title: `${monthLabel} のシフト希望を提出してください`,
          body: `${monthLabel} のシフト希望が未提出です。 期限内にご提出をお願いします。`,
        });
      }
      if (rows.length === 0) {
        alert('送信可能な通知がありません\n\n' + skipped.join('\n'));
        return;
      }
      const { error } = await supabase.from('staff_notifications').insert(rows);
      if (error) throw error;
      await writeClientAudit({
        organizationId: currentOrganization.id,
        actionType: 'create',
        targetTable: 'staff_notifications',
        targetSummary: `シフト希望の催促通知を ${rows.length} 名に送信 (${monthLabel})`,
        changes: { recipientCount: rows.length, monthLabel, skippedCount: skipped.length },
        success: true,
      });
      const msg = `${rows.length} 名にアプリ内通知を送信しました`
        + (skipped.length ? `\n\n送信できなかった対象:\n${skipped.join('\n')}` : '');
      alert(msg);
    } catch (e) {
      console.error('催促通知送信エラー:', e);
      await writeClientAudit({
        organizationId: currentOrganization?.id,
        actionType: 'create',
        targetTable: 'staff_notifications',
        targetSummary: `シフト希望の催促通知送信に失敗`,
        success: false,
        errorMessage: e.message,
      });
      alert('通知の送信に失敗しました: ' + e.message);
    }
  };

  const handleChange = async (empId, date, value) => {
    const key = `${empId}_${date}`;
    
    // 1. State更新（シフトカウントは非同期で）
    setShiftMatrix((prev) => {
      const newMatrix = { ...prev, [key]: value };
      
      // 🔥 重い処理を非同期に
      setTimeout(() => {
        updateShiftCounts(newMatrix, uniqueEmployeeIds, dates);
      }, 0);
      
      return newMatrix;
    });
    
    // 2. 即座に保存
    await saveShiftImmediately(empId, date, value);
  };
  
  // 即座保存用の関数
  // 即座保存用の関数（詳細ログ版）
const saveShiftImmediately = async (empId, date, value) => {
  try {
    if (!currentOrganization?.id) {
      console.error('組織IDが取得できません');
      return;
    }
    const organizationId = currentOrganization.id;
    
    console.log("💾 シフト自動保存開始:", { 
      empId, 
      date, 
      value, 
      organizationId 
    });
    
    // 🔥 保存するデータを明示的に作成
    const recordToSave = {
      organization_id: organizationId,
      employee_id: empId,
      shift_date: date,
      shift_type: value,
      updated_at: new Date().toISOString()
    };
    
    console.log("📤 Supabaseに送信するデータ:", recordToSave);
    
    const { data, error } = await supabase
      .from('monthly_shifts')
      .upsert(recordToSave, { 
        onConflict: 'organization_id,employee_id,shift_date'
      })
      .select(); // 🔥 .select()を追加して結果を取得
    
    console.log("📥 Supabaseレスポンス:", { data, error });
    
    if (error) {
      console.error("❌ Supabase保存エラー:", error);
      
      // エラー通知
      const notification = document.createElement('div');
      notification.innerHTML = `
        <div style="
          position: fixed; 
          top: 80px; 
          right: 20px; 
          background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%); 
          color: white; 
          padding: 12px 20px; 
          border-radius: 12px; 
          z-index: 10000;
          font-size: 14px;
          font-weight: 600;
          box-shadow: 0 4px 15px rgba(220, 38, 38, 0.4);
        ">
          ❌ 保存失敗: ${error.message}
        </div>
      `;
      document.body.appendChild(notification);
      
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 3000);
      
      throw error;
    }
    
    // 🔥 dataがnullまたは空の場合も警告
    if (!data || data.length === 0) {
      console.warn("⚠️ 保存完了したがデータが返されませんでした");
    } else {
      console.log("✅ シフト自動保存完了（確認済み）:", data);
    }
    
    // 成功通知
    const successNotification = document.createElement('div');
    successNotification.innerHTML = `
      <div style="
        position: fixed; 
        bottom: 20px; 
        right: 20px; 
        background: linear-gradient(135deg, #16a34a 0%, #15803d 100%); 
        color: white; 
        padding: 8px 16px; 
        border-radius: 20px; 
        z-index: 10000;
        font-size: 12px;
        font-weight: 600;
        box-shadow: 0 4px 15px rgba(22, 163, 74, 0.3);
        animation: fadeInOut 2s ease-in-out;
      ">
        ✅ 保存完了
      </div>
      <style>
        @keyframes fadeInOut {
          0% { opacity: 0; transform: translateY(10px); }
          15%, 85% { opacity: 1; transform: translateY(0); }
          100% { opacity: 0; transform: translateY(-10px); }
        }
      </style>
    `;
    document.body.appendChild(successNotification);
    
    setTimeout(() => {
      if (successNotification.parentNode) {
        successNotification.parentNode.removeChild(successNotification);
      }
    }, 2000);
    
  } catch (error) {
    console.error("❌ シフト自動保存エラー（catch）:", error);
  }
};

  const getDisplayName = (empId) => {
    const staff = staffList.find((s) => s.employeeId === empId);
    return staff ? `${staff.lastName} ${staff.firstName}` : empId;
  };

  const getHopeLabel = (key) => {
    const hopeValue = hopes[key];
    if (!hopeValue) return "";
    
    // hopeOptionsから該当するラベルを検索
    const option = hopeOptions.find(opt => opt.value === hopeValue);
    if (option) {
      return option.label;
    }
    
    // 見つからない場合は値をそのまま返す
    return hopeValue;
  };

  // 希望の状態を取得（個人提出/管理者設定/なし）
  const getHopeStatus = (empId, date) => {
    const key = `${empId}_${date}`;
    const hasOriginalHope = originalHopes[key] !== undefined && originalHopes[key] !== "";
    const hasAdminHope = adminHopes[key] !== undefined;
    
    if (hasAdminHope) {
      return { type: 'admin', hope: adminHopes[key] };
    } else if (hasOriginalHope) {
      return { type: 'original', hope: originalHopes[key] };
    }
    return { type: 'none', hope: '' };
  };

  // スタッフ別集計データ
  const staffShiftData = useMemo(() => {
    if (uniqueEmployeeIds.length === 0 || dates.length === 0) {
      return { staffCounts: {}, averages: {}, totals: {} };
    }
    return calculateStaffShiftCounts(shiftMatrix, uniqueEmployeeIds, dates);
  }, [shiftMatrix, uniqueEmployeeIds, dates]);

  // シフト回数の偏差を取得（平均との差）
  const getShiftDeviation = (empId, shiftType) => {
    const count = staffShiftData.staffCounts[empId]?.counts[shiftType] || 0;
    const average = staffShiftData.averages[shiftType] || 0;
    return count - average;
  };

  // 偏差に基づく色を取得
  const getDeviationColor = (deviation) => {
    if (Math.abs(deviation) < 1) return '#10b981'; // 平均的（緑）
    if (deviation > 2) return '#dc2626';           // 多すぎ（赤）
    if (deviation > 0) return '#f59e0b';           // やや多い（オレンジ）
    if (deviation < -2) return '#3b82f6';          // 少なすぎ（青）
    return '#6b7280';                              // やや少ない（グレー）
  };

  const getEventLabel = (key) => (events[key] ? (
    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
      <Bell size={12} style={{ marginRight: '2px' }} />
      {events[key]}
    </span>
  ) : "");

  // shiftAutoAssign の getConsecutiveContribution と整合させた累計値ベース連勤計算。
  //   - パターン設定 consecutive_contribution が明示されていればそれを使用
  //   - 未設定なら自動判定: request_group ∈ {off, paid, summer} = 0、その他 = 1
  //   - 0 を返したマークは連勤を切る
  const REST_REQUEST_GROUPS_ADMIN = new Set(["off", "paid", "summer"]);
  const buildPatternByMarkAdmin = (pats) => {
    const patternByMark = {};
    (pats || []).forEach((p) => {
      if (p.displayMark) patternByMark[p.displayMark] = p;
      if (p.shortName && !patternByMark[p.shortName]) patternByMark[p.shortName] = p;
    });
    return patternByMark;
  };
  const getMarkContributionAdmin = (mark, pats, patternByMark) => {
    if (!mark || mark === "休") return 0;
    const p = patternByMark[mark] || (pats || []).find((x) => x.displayMark === mark);
    if (!p) return 1;
    const cfg = p.configuration || {};
    const explicit = p.consecutiveContribution ?? cfg.consecutive_contribution;
    if (explicit != null && Number.isFinite(Number(explicit))) return Number(explicit);
    const rg = cfg.request_group || p.requestGroup;
    if (REST_REQUEST_GROUPS_ADMIN.has(rg)) return 0;
    return 1;
  };
  // 🔥 ユーザーが明示的に寄与度を設定したかどうか。
  //   true なら isFollowMarkAdmin で 0 上書きしてはならない（ユーザー設定を尊重）。
  const hasExplicitContributionAdmin = (mark, pats, patternByMark) => {
    if (!mark) return false;
    const p = patternByMark[mark] || (pats || []).find((x) => x.displayMark === mark);
    if (!p) return false;
    const cfg = p.configuration || {};
    const e = p.consecutiveContribution ?? cfg.consecutive_contribution;
    return e != null && Number.isFinite(Number(e));
  };
  const isFollowMarkAdmin = (dates, idx, matrix, staffId, pats, patternByMark, priorMatrix = {}) => {
    const today = matrix[`${staffId}_${dates[idx]}`];
    if (!today) return false;
    let prev;
    if (idx === 0) {
      const prevDate = dayjs(dates[0]).subtract(1, 'day').format('YYYY-MM-DD');
      prev = priorMatrix[`${staffId}_${prevDate}`];
    } else {
      prev = matrix[`${staffId}_${dates[idx - 1]}`];
    }
    if (!prev) return false;
    const prevPattern = patternByMark[prev];
    const prevIds =
      (prevPattern?.configuration?.post_shift_ids) ||
      prevPattern?.postShiftIds || [];
    if (prevIds.length === 0) return false;
    return prevIds.some((ref) => {
      const target = (pats || []).find((q) => q.id === ref) || patternByMark[ref];
      return target?.displayMark === today;
    });
  };

  const calculateMaxConsecutiveDays = (staffId, dates, matrix, pats, priorMatrix = {}) => {
    const patternByMark = buildPatternByMarkAdmin(pats);
    let maxSum = 0;
    let currentSum = 0;
    let maxStart = -1;
    let maxEnd = -1;
    let currentStart = -1;

    // 🔥 前月末から続く連勤を初期 currentSum に積む（月またぎ対応）
    let priorSum = 0;
    if (dates.length > 0) {
      let d = dayjs(dates[0]).subtract(1, 'day');
      for (let i = 0; i < 30; i++) {
        const ds = d.format('YYYY-MM-DD');
        const shift = priorMatrix[`${staffId}_${ds}`];
        if (!shift) break;
        const contrib = getMarkContributionAdmin(shift, pats, patternByMark);
        if (contrib <= 0) break;
        priorSum += contrib;
        d = d.subtract(1, 'day');
      }
    }
    if (priorSum > 0) {
      currentSum = priorSum;
      currentStart = -1;
      if (currentSum > maxSum) {
        maxSum = currentSum;
        maxStart = -1;
        maxEnd = -1;
      }
    }

    dates.forEach((date, index) => {
      const key = `${staffId}_${date}`;
      const shift = matrix[key];
      if (!shift) {
        currentSum = 0;
        return;
      }
      // 🔥 明示的寄与度設定があれば、follow 判定での 0 上書きを行わない。
      const contribRaw = getMarkContributionAdmin(shift, pats, patternByMark);
      const explicit = hasExplicitContributionAdmin(shift, pats, patternByMark);
      const follow = !explicit && isFollowMarkAdmin(dates, index, matrix, staffId, pats, patternByMark, priorMatrix);
      const contrib = follow ? 0 : contribRaw;
      if (contrib <= 0) {
        currentSum = 0;
        return;
      }
      if (currentSum === 0) currentStart = index;
      currentSum += contrib;
      if (currentSum > maxSum) {
        maxSum = currentSum;
        maxStart = currentStart;
        maxEnd = index;
      }
    });

    return {
      max: maxSum,
      start: maxStart,
      end: maxEnd
    };
  };

  // 横レイアウト用のスタッフシフト集計コンポーネント（groupName対応版）
  const renderStaffShiftSummaryHorizontal = (empId) => {
    // groupNameベースでの表示を優先
    const sortedGroups = getSortedShiftTypes(
      shiftTypeCounts.groupTypes,
      shiftTypeCounts.groupCounts,
      'priority',
      true // groupName表示を使用
    ).filter(([groupName]) => {
      // このスタッフがそのグループのシフトを持っているかチェック
      const groupCount = staffShiftData.staffGroupCounts[empId]?.groupCounts[groupName] || 0;
      return groupCount > 0;
    });

    // 集計欄バッジ：showInAggregation=true の shift_patterns を抽出
    //   公休（mark='休'）は annual_total / monthly_limit 未指定なら
    //   holiday_policies.annual_target から自動補完
    const annualTarget = settings?.holidayPolicy?.annualTarget || 0;
    const defaultMonthlyHoliday = Math.round(annualTarget / 12);
    const holidayMarks = Object.entries(shiftTypeCounts.types || {}).filter(
      ([, info]) => info.showInAggregation
    );
    if (empId === uniqueEmployeeIds?.[0]) {
      // 最初の1人だけ診断ログ出力（連発防止）
      console.log('🏷️ 集計バッジ対象マーク:', holidayMarks.map(([m, i]) => ({
        mark: m,
        name: i.name,
        period: i.aggregationPeriod,
        monthlyLimit: i.holidayMonthlyLimit,
        annualTotal: i.holidayAnnualTotal,
        rate: i.showAcquisitionRate,
      })));
    }

    return (
      <div style={modernStyles.staffSummaryHorizontal}>
        {sortedGroups.map(([groupName, groupInfo]) => {
          const count = staffShiftData.staffGroupCounts[empId]?.groupCounts[groupName] || 0;
          const average = staffShiftData.groupAverages[groupName] || 0;
          const deviation = count - average;
          const deviationColor = getDeviationColor(deviation);
          
          return (
            <div
              key={groupName}
              style={{
                ...modernStyles.shiftBadgeHorizontal,
                background: groupInfo.bg,
                borderColor: groupInfo.color,
                color: groupInfo.color,
              }}
              title={`${groupInfo.name}: ${count}回 (平均${average.toFixed(1)}回, 差${deviation > 0 ? '+' : ''}${deviation.toFixed(1)})`}
            >
              <span style={{ fontSize: '8px', fontWeight: '500' }}>
                {groupInfo.name}
              </span>
              <span style={{ fontWeight: '700' }}>
                {count}
              </span>
              {Math.abs(deviation) >= 1 && (
                <div
                  style={{
                    position: 'absolute',
                    top: '-4px',
                    right: '-4px',
                    fontSize: '6px',
                    fontWeight: '700',
                    color: 'white',
                    background: deviationColor,
                    padding: '1px 2px',
                    borderRadius: '6px',
                    minWidth: '12px',
                    textAlign: 'center',
                    lineHeight: '1',
                  }}
                >
                  {deviation > 0 ? '+' : ''}{Math.round(deviation)}
                </div>
              )}
            </div>
          );
        })}

        {/* 集計バッジ（公休 / 夏休み などの取得状況） */}
        {holidayMarks.map(([mark, info]) => {
          // 集計期間に応じて分子・分母を決定
          //   monthly: 当月の取得数 / 月間取得上限
          //   annual : 年度累計（4月〜表示月）= 過去月（DB）+ 当月（matrix） / 年間総日数
          const period = info.aggregationPeriod === 'annual' ? 'annual' : 'monthly';
          const monthlyCount = staffShiftData.staffCounts[empId]?.counts[mark] || 0;
          const priorCount = annualHolidayCounts[String(empId)]?.[mark] || 0;
          const fiscalCount = priorCount + monthlyCount;

          const annualTotal =
            info.holidayAnnualTotal != null
              ? info.holidayAnnualTotal
              : mark === '休'
                ? annualTarget || null
                : null;
          // 月毎詳細設定（holidayMonthlyLimitByMonth）が指定されていれば優先、
          // なければ単一値 holidayMonthlyLimit、それも無ければ公休デフォルト
          const displayMonth = currentMonth; // Admin.js の表示中の月（1-12）
          const byMonth = info.holidayMonthlyLimitByMonth;
          const byMonthVal =
            byMonth && byMonth[displayMonth] != null
              ? Number(byMonth[displayMonth])
              : byMonth && byMonth[String(displayMonth)] != null
                ? Number(byMonth[String(displayMonth)])
                : null;
          const monthlyLimit =
            byMonthVal != null
              ? byMonthVal
              : info.holidayMonthlyLimit != null
                ? info.holidayMonthlyLimit
                : mark === '休'
                  ? defaultMonthlyHoliday || null
                  : null;

          const count = period === 'annual' ? fiscalCount : monthlyCount;
          const limit = period === 'annual' ? annualTotal : monthlyLimit;

          const showRate = info.showAcquisitionRate && limit && limit > 0;
          const rate = showRate ? Math.round((count / limit) * 100) : 0;
          // 取得率に応じた色
          let rateColor = '#10b981';
          if (showRate) {
            if (rate >= 100) rateColor = '#10b981';
            else if (rate >= 70) rateColor = '#f59e0b';
            else rateColor = '#dc2626';
          }
          const titleParts = [
            `${info.name}: ${period === 'annual'
              ? `年度累計 ${fiscalCount} 日（4月〜前月まで ${priorCount} + 当月 ${monthlyCount}）`
              : `当月 ${monthlyCount} 日`}`,
          ];
          if (monthlyLimit) titleParts.push(`月間上限 ${monthlyLimit} 日`);
          if (annualTotal) titleParts.push(`年間総日数 ${annualTotal} 日`);
          return (
            <div
              key={`aggr-${mark}`}
              style={{
                ...modernStyles.shiftBadgeHorizontal,
                background: '#fef3c7',
                borderColor: '#f59e0b',
                color: '#92400e',
                position: 'relative',
              }}
              title={titleParts.join(' / ')}
            >
              <span style={{ fontSize: '8px', fontWeight: '500' }}>
                {info.name}{period === 'annual' ? '(年度)' : ''}
              </span>
              <span style={{ fontWeight: '700' }}>
                {limit ? `${count}/${limit}` : count}
              </span>
              {showRate && (
                <div
                  style={{
                    position: 'absolute',
                    top: '-4px',
                    right: '-4px',
                    fontSize: '6px',
                    fontWeight: '700',
                    color: 'white',
                    background: rateColor,
                    padding: '1px 3px',
                    borderRadius: '6px',
                    minWidth: '14px',
                    textAlign: 'center',
                    lineHeight: '1',
                  }}
                >
                  {rate}%
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  // 集中モード用：クリックで次の選択肢に切り替え
const handleCellClick = (empId, date, currentValue, isHopeMode) => {
  if (isHopeMode) {
    // 希望モード
    const currentIndex = hopeOptions.findIndex(opt => opt.value === currentValue);
    const nextIndex = (currentIndex + 1) % hopeOptions.length;
    const nextValue = hopeOptions[nextIndex].value;
    handleAdminHopeChange(empId, date, nextValue);
  } else {
    // シフトモード
    const currentIndex = shiftOptions.indexOf(currentValue);
    const nextIndex = (currentIndex + 1) % shiftOptions.length;
    const nextValue = shiftOptions[nextIndex];
    handleChange(empId, date, nextValue);
  }
};

// 右クリックで逆順に切り替え
const handleCellRightClick = (e, empId, date, currentValue, isHopeMode) => {
  e.preventDefault();
  if (isHopeMode) {
    const currentIndex = hopeOptions.findIndex(opt => opt.value === currentValue);
    const prevIndex = currentIndex - 1 < 0 ? hopeOptions.length - 1 : currentIndex - 1;
    const prevValue = hopeOptions[prevIndex].value;
    handleAdminHopeChange(empId, date, prevValue);
  } else {
    const currentIndex = shiftOptions.indexOf(currentValue);
    const prevIndex = currentIndex - 1 < 0 ? shiftOptions.length - 1 : currentIndex - 1;
    const prevValue = shiftOptions[prevIndex];
    handleChange(empId, date, prevValue);
  }
};

// セル選択ハンドラー
const handleCellSelect = (empId, date, isShiftKey, event) => {
  event.stopPropagation();  // ✅ これを追加！

  const cellId = `${empId}_${date}`;

  console.log("🔥 handleCellSelect呼ばれた!", { empId, date, dropdownCell });

  // すでにドロップダウンが表示されている場合は閉じる
  if (dropdownCell === cellId) {
    setDropdownCell(null);
    setDropdownAnchor(null);
    return;
  }

  // 🔥 td 要素の viewport 座標を取得して Portal 描画用に保存
  const rect = event.currentTarget.getBoundingClientRect();
  setDropdownAnchor({
    top: rect.bottom,
    left: rect.left + rect.width / 2,
    width: rect.width,
  });
  
  if (isShiftKey && lastSelectedCell) {
    // Shift+クリック: 範囲選択
    const allCells = [];
    const staffIds = getSortedStaffIds(staffList, customStaffOrder);
    const startStaffIndex = staffIds.indexOf(lastSelectedCell.empId);
    const endStaffIndex = staffIds.indexOf(empId);
    const startDateIndex = dates.indexOf(lastSelectedCell.date);
    const endDateIndex = dates.indexOf(date);
    
    const minStaff = Math.min(startStaffIndex, endStaffIndex);
    const maxStaff = Math.max(startStaffIndex, endStaffIndex);
    const minDate = Math.min(startDateIndex, endDateIndex);
    const maxDate = Math.max(startDateIndex, endDateIndex);
    
    for (let i = minStaff; i <= maxStaff; i++) {
      for (let j = minDate; j <= maxDate; j++) {
        allCells.push({ empId: staffIds[i], date: dates[j] });
      }
    }
    setSelectedCells(allCells);
    setDropdownCell(null);
    setDropdownAnchor(null);
  } else {
    // 通常クリック: 単一選択 + ドロップダウン表示
    setSelectedCells([{ empId, date }]);
    setLastSelectedCell({ empId, date });
    setDropdownCell(cellId);
    console.log("📍 dropdownCell設定:", cellId);
  }
};

// ドロップダウンから選択
const handleDropdownSelect = (empId, date, value) => {
  if (focusModeTab === 'hope') {
    handleAdminHopeChange(empId, date, value);
  } else {
    handleChange(empId, date, value);
  }
  setDropdownCell(null); // 選択後は閉じる
  setDropdownAnchor(null);
};

// コピー処理
const handleCopy = () => {
  if (selectedCells.length === 0) return;
  
  const data = selectedCells.map(cell => {
    const key = `${cell.empId}_${cell.date}`;
    return {
      empId: cell.empId,
      date: cell.date,
      value: focusModeTab === 'hope' ? (hopes[key] || "") : (shiftMatrix[key] || "")
    };
  });
  
  setClipboardData(data);
  console.log("📋 コピー:", data.length, "セル");
};

// ペースト処理
const handlePaste = () => {
  if (clipboardData.length === 0 || selectedCells.length === 0) return;
  
  const baseCell = selectedCells[0]; // 貼り付け開始位置
  const staffIds = getSortedStaffIds(staffList, customStaffOrder);
  const baseStaffIndex = staffIds.indexOf(baseCell.empId);
  const baseDateIndex = dates.indexOf(baseCell.date);
  
  // コピー元の形状を計算
  const copyStaffIds = [...new Set(clipboardData.map(d => d.empId))];
  const copyDates = [...new Set(clipboardData.map(d => d.date))];
  const copyHeight = copyStaffIds.length;
  const copyWidth = copyDates.length;
  
  clipboardData.forEach(item => {
    const offsetStaff = copyStaffIds.indexOf(item.empId);
    const offsetDate = copyDates.indexOf(item.date);
    const targetStaffIndex = baseStaffIndex + offsetStaff;
    const targetDateIndex = baseDateIndex + offsetDate;
    
    if (targetStaffIndex < staffIds.length && targetDateIndex < dates.length) {
      const targetEmpId = staffIds[targetStaffIndex];
      const targetDate = dates[targetDateIndex];
      
      if (focusModeTab === 'hope') {
        handleAdminHopeChange(targetEmpId, targetDate, item.value);
      } else {
        handleChange(targetEmpId, targetDate, item.value);
      }
    }
  });
  
  console.log("📌 ペースト完了:", clipboardData.length, "セル");
};


// ショートカットキー入力（動的マッピング対応版）
const handleShortcutInput = (key) => {
  if (selectedCells.length === 0) return;
  
  // ✅ 動的マッピングから値を取得
  const value = shortcutKeyMap[key];
  
  if (value !== undefined) {
    selectedCells.forEach(cell => {
      if (focusModeTab === 'hope') {
        handleAdminHopeChange(cell.empId, cell.date, value);
      } else {
        handleChange(cell.empId, cell.date, value);
      }
    });
    
    // 入力通知
    const notification = document.createElement('div');
    notification.innerHTML = `
      <div style="
        position: fixed; 
        bottom: 20px; 
        left: 50%; 
        transform: translateX(-50%); 
        background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%); 
        color: white; 
        padding: 8px 16px; 
        border-radius: 20px; 
        z-index: 10000;
        font-size: 12px;
        font-weight: 600;
        box-shadow: 0 4px 15px rgba(139, 92, 246, 0.3);
        animation: fadeInOut 1s ease-in-out;
      ">
        ⌨️ [${key}] → ${value || '日勤'}
      </div>
    `;
    document.body.appendChild(notification);
    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification);
      }
    }, 1000);
  }
};

// 矢印キーでセル移動
const handleArrowKeyNavigation = (key) => {
  if (selectedCells.length === 0) return;
  
  const currentCell = selectedCells[0]; // 最初の選択セルを基準
  const staffIds = getSortedStaffIds(staffList, customStaffOrder);
  const currentStaffIndex = staffIds.indexOf(currentCell.empId);
  const currentDateIndex = dates.indexOf(currentCell.date);
  
  let newStaffIndex = currentStaffIndex;
  let newDateIndex = currentDateIndex;
  
  switch (key) {
    case 'ArrowUp':
      newStaffIndex = Math.max(0, currentStaffIndex - 1);
      break;
    case 'ArrowDown':
      newStaffIndex = Math.min(staffIds.length - 1, currentStaffIndex + 1);
      break;
    case 'ArrowLeft':
      newDateIndex = Math.max(0, currentDateIndex - 1);
      break;
    case 'ArrowRight':
      newDateIndex = Math.min(dates.length - 1, currentDateIndex + 1);
      break;
  }
  
  const newEmpId = staffIds[newStaffIndex];
  const newDate = dates[newDateIndex];
  
  setSelectedCells([{ empId: newEmpId, date: newDate }]);
  setLastSelectedCell({ empId: newEmpId, date: newDate });
  setDropdownCell(null); // 移動時はドロップダウンを閉じる
  setDropdownAnchor(null);
  
  console.log("🎯 セル移動:", { newEmpId, newDate });
};

// キーボードイベントリスナー
useEffect(() => {
  if (!isFocusMode) return;
  
  const handleKeyDown = (e) => {
    // Ctrl+C: コピー
    if (e.ctrlKey && e.key === 'c') {
      e.preventDefault();
      handleCopy();
    }
    // Ctrl+V: ペースト
    else if (e.ctrlKey && e.key === 'v') {
      e.preventDefault();
      handlePaste();
    }
    // 数字キー: ショートカット入力
    else if (/^[0-9]$/.test(e.key)) {
      e.preventDefault();
      handleShortcutInput(e.key);
    }
  };
  
  window.addEventListener('keydown', handleKeyDown);
  return () => window.removeEventListener('keydown', handleKeyDown);
}, [isFocusMode, selectedCells, clipboardData, focusModeTab, hopes, shiftMatrix]);

// 集中モードのスクロールバースタイルを動的追加（最終版）
useEffect(() => {
  if (!isFocusMode) return;
  
  console.log("🎨 スクロールバースタイル適用中...");
  
  const styleId = 'focus-mode-scrollbar-style';
  let styleTag = document.getElementById(styleId);
  
  if (!styleTag) {
    styleTag = document.createElement('style');
    styleTag.id = styleId;
    styleTag.innerHTML = `
      /* 本番用：ダークグレーのスクロールバー */
      div[id="focus-mode-scroll-container"]::-webkit-scrollbar {
        -webkit-appearance: none !important;
        width: 16px !important;
        height: 16px !important;
      }
      
      div[id="focus-mode-scroll-container"]::-webkit-scrollbar-track {
        background: #1f2937 !important;
        border-radius: 0 !important;
      }
      
      div[id="focus-mode-scroll-container"]::-webkit-scrollbar-thumb {
        background: #4b5563 !important;
        border-radius: 8px !important;
        border: 3px solid #1f2937 !important;
      }
      
      div[id="focus-mode-scroll-container"]::-webkit-scrollbar-thumb:hover {
        background: #6b7280 !important;
      }
      
      div[id="focus-mode-scroll-container"]::-webkit-scrollbar-corner {
        background: #1f2937 !important;
      }
      
      /* Firefox用 */
      div[id="focus-mode-scroll-container"] {
        scrollbar-width: auto !important;
        scrollbar-color: #4b5563 #1f2937 !important;
      }
    `;
    document.head.appendChild(styleTag);
    console.log("✅ スタイルタグ追加完了");
  }
  
  return () => {
    const style = document.getElementById(styleId);
    if (style) {
      style.remove();
    }
  };
}, [isFocusMode]);

// ドロップダウン外クリックで閉じる
useEffect(() => {
  if (!isFocusMode || !dropdownCell) return;
  
  const handleClickOutside = (e) => {
    console.log("🌍 外クリック検知");
    setDropdownCell(null);
    setDropdownAnchor(null);
  };
  
  // 次のイベントループで登録（即座のクリックを防ぐ）
  const timerId = setTimeout(() => {
    document.addEventListener('click', handleClickOutside);
  }, 0);
  
  return () => {
    clearTimeout(timerId);
    document.removeEventListener('click', handleClickOutside);
  };
}, [isFocusMode, dropdownCell]);

// ショートカットキー設定の読み込み（完全汎用版）
useEffect(() => {
  const loadShortcutKeys = async () => {
    try {
      if (!currentOrganization?.id) {
        console.error('組織IDが取得できません');
        return;
      }
      const organizationId = currentOrganization.id;
      
      // ⚠️ Supabase Auth では currentUser.id（UUID）。Firebase 時代の uid ではない
      const userId = currentUser?.id;
      if (!userId) {
        console.warn('currentUser.id が未取得のためショートカット読み込みをスキップ');
        return;
      }
      const { data, error } = await supabase
        .from('user_preferences')
        .select('shortcut_keys')
        .eq('organization_id', organizationId)
        .eq('user_id', userId)
        .maybeSingle();
      
      if (error && error.code !== 'PGRST116') {
        console.error("ショートカットキー読み込みエラー:", error);
      }
      
      if (data?.shortcut_keys) {
        setShortcutKeyMap(data.shortcut_keys);
      } else {
        // ✅ デフォルト：displayOrderの順に自動割り当て（オプション1）
        const sortedPatterns = [...shiftPatterns]
          .filter(p => p.isActive !== false)
          .sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
        
        const defaultMap = {};
        sortedPatterns.slice(0, 10).forEach((pattern, index) => {
          const mark = pattern.shortName || pattern.displayMark || pattern.name;
          defaultMap[String(index)] = mark;
        });
        
        // 休みを追加（どの組織でも共通の可能性が高い）
        if (!Object.values(defaultMap).includes('休')) {
          const emptyKey = ['9', '8', '7', '6', '5', '4', '3', '2', '1', '0']
            .find(k => !defaultMap[k]);
          if (emptyKey) {
            defaultMap[emptyKey] = '休';
          }
        }
        
        setShortcutKeyMap(defaultMap);
        
        console.log("✅ デフォルトショートカット設定:", defaultMap);
      }
    } catch (error) {
      console.error("ショートカットキー読み込みエラー:", error);
    }
  };
  
  if (currentUser && shiftPatterns.length > 0) {
    loadShortcutKeys();
  }
}, [currentUser, currentOrganization?.id, shiftPatterns]);



// ショートカットキー設定を保存
// ショートカットキー設定を保存（エラーハンドリング改善版）
const saveShortcutKeys = async (newKeyMap) => {
  try {
    if (!currentOrganization?.id) {
      console.error('組織IDが取得できません');
      return;
    }
    const organizationId = currentOrganization.id;

    // ⚠️ Supabase Auth では currentUser.id（UUID）
    const userId = currentUser?.id;
    if (!userId) {
      console.warn('currentUser.id が未取得のためショートカット保存をスキップ');
      return;
    }

    const { error } = await supabase
      .from('user_preferences')
      .upsert({
        organization_id: organizationId,
        user_id: userId,
        shortcut_keys: newKeyMap,
        updated_at: new Date().toISOString()
      }, {
        onConflict: 'organization_id,user_id'
      });
    
    // ✅ エラーがあってもキャッシュエラーなら無視
    if (error && !error.message.includes('schema cache')) {
      console.error("ショートカットキー保存エラー:", error);
      throw error;
    }
    
    setShortcutKeyMap(newKeyMap);
    
    // 成功通知
    const notification = document.createElement('div');
    notification.innerHTML = `
      <div style="
        position: fixed; 
        top: 80px; 
        left: 50%; 
        transform: translateX(-50%); 
        background: linear-gradient(135deg, #16a34a 0%, #15803d 100%); 
        color: white; 
        padding: 12px 24px; 
        border-radius: 25px; 
        z-index: 10000;
        font-weight: 600;
        box-shadow: 0 8px 25px rgba(22, 163, 74, 0.4);
        animation: fadeInOut 2s ease-in-out;
      ">
        ✅ ショートカットキーを保存しました
      </div>
    `;
    document.body.appendChild(notification);
    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification);
      }
    }, 2000);
    
  } catch (error) {
    console.error("ショートカットキー保存エラー:", error);
    alert("保存に失敗しました: " + error.message);
  }
};

// キーボードイベントリスナー（修正版）
useEffect(() => {
  if (!isFocusMode) return;
  
  const handleKeyDown = (e) => {
    // Ctrl+C: コピー
    if (e.ctrlKey && e.key === 'c') {
      e.preventDefault();
      handleCopy();
      
      // ✅ コピー成功通知
      const notification = document.createElement('div');
      notification.innerHTML = `
        <div style="
          position: fixed; 
          bottom: 20px; 
          right: 20px; 
          background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%); 
          color: white; 
          padding: 8px 16px; 
          border-radius: 20px; 
          z-index: 10000;
          font-size: 12px;
          font-weight: 600;
          box-shadow: 0 4px 15px rgba(59, 130, 246, 0.3);
          animation: fadeInOut 1.5s ease-in-out;
        ">
          📋 ${selectedCells.length}セルをコピー
        </div>
        <style>
          @keyframes fadeInOut {
            0% { opacity: 0; transform: translateY(10px); }
            15%, 85% { opacity: 1; transform: translateY(0); }
            100% { opacity: 0; transform: translateY(-10px); }
          }
        </style>
      `;
      document.body.appendChild(notification);
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 1500);
    }
    // Ctrl+V: ペースト
    else if (e.ctrlKey && e.key === 'v') {
      e.preventDefault();
      handlePaste();
      
      // ✅ ペースト成功通知
      const notification = document.createElement('div');
      notification.innerHTML = `
        <div style="
          position: fixed; 
          bottom: 20px; 
          right: 20px; 
          background: linear-gradient(135deg, #10b981 0%, #059669 100%); 
          color: white; 
          padding: 8px 16px; 
          border-radius: 20px; 
          z-index: 10000;
          font-size: 12px;
          font-weight: 600;
          box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3);
          animation: fadeInOut 1.5s ease-in-out;
        ">
          📌 ${clipboardData.length}セルをペースト
        </div>
      `;
      document.body.appendChild(notification);
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 1500);
    }
    // 数字キー: ショートカット入力
    else if (/^[0-9]$/.test(e.key)) {
      e.preventDefault();
      handleShortcutInput(e.key);
    }
    // 矢印キー: セル移動
    else if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
      e.preventDefault();
      handleArrowKeyNavigation(e.key);
    }
  };
  
  window.addEventListener('keydown', handleKeyDown);
  return () => window.removeEventListener('keydown', handleKeyDown);
}, [isFocusMode, selectedCells, clipboardData, lastSelectedCell, focusModeTab, hopes, shiftMatrix, staffList, customStaffOrder, dates]); // ✅ 依存配列を拡張

// 表示用ラベル取得
const getCellDisplayLabel = (value, isHopeMode) => {
  if (!value) return "-";
  if (isHopeMode) {
    const option = hopeOptions.find(opt => opt.value === value);
    return option ? option.label.substring(0, 2) : value.substring(0, 2);
  }
  // ⚠️ 旧仕様の「空=日勤」は Phase F で廃止。空文字も「未定」として "-" を返す。
  return value === "" ? "-" : value.substring(0, 2);
};

  if (loading) return (
    <div style={modernStyles.container}>
      <Header />
      <div style={modernStyles.contentWrapper}>
        <div style={{ textAlign: 'center', padding: '60px 0' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
            <Loader size={32} style={{ animation: 'spin 2s linear infinite', color: '#667eea' }} />
            <h2 style={{ margin: 0, color: '#1f2937', fontSize: '24px', fontWeight: '700' }}>
              データを読み込み中...
            </h2>
          </div>
          <div style={modernStyles.progressBar}>
            <div style={{ ...modernStyles.progressFill, width: '60%' }} />
          </div>
          <p style={{ color: '#6b7280', fontSize: '16px', margin: '16px 0 0 0' }}>
            スタッフ情報とシフトデータを取得しています
          </p>
        </div>
      </div>
    </div>
  );

  if (loading) return (
    <div style={modernStyles.container}>
      <Header />
      <div style={modernStyles.contentWrapper}>
        <div style={{ textAlign: 'center', padding: '60px 0' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
            <Loader size={32} style={{ animation: 'spin 2s linear infinite', color: '#667eea' }} />
            <h2 style={{ margin: 0, color: '#1f2937', fontSize: '24px', fontWeight: '700' }}>
              データを読み込み中...
            </h2>
          </div>
          <div style={modernStyles.progressBar}>
            <div style={{ ...modernStyles.progressFill, width: '60%' }} />
          </div>
          <p style={{ color: '#6b7280', fontSize: '16px', margin: '16px 0 0 0' }}>
            スタッフ情報とシフトデータを取得しています
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <>
    {/* シフト自動作成中のローディングオーバーレイ */}
    {isLoading && (
      <div
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(15, 23, 42, 0.75)',
          backdropFilter: 'blur(4px)',
          zIndex: 99999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {/* 🔥 スピナー用 CSS keyframes（インライン定義）。CSS アニメーションは JS スレッドが
            ブロックされても動くので、計算中であることを確実にユーザーに伝えられる。 */}
        <style>{`
          @keyframes shiftgen-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          @keyframes shiftgen-pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.4; }
          }
          @keyframes shiftgen-dots {
            0%, 20% { content: ''; }
            40% { content: '.'; }
            60% { content: '..'; }
            80%, 100% { content: '...'; }
          }
          .shiftgen-dots::after {
            content: '';
            animation: shiftgen-dots 1.4s steps(1, end) infinite;
            display: inline-block;
            width: 1.5em;
            text-align: left;
          }
          .shiftgen-bar-stripe {
            background-image: linear-gradient(
              45deg,
              rgba(255,255,255,0.25) 25%, transparent 25%,
              transparent 50%, rgba(255,255,255,0.25) 50%,
              rgba(255,255,255,0.25) 75%, transparent 75%, transparent
            );
            background-size: 28px 28px;
            animation: shiftgen-bar-move 1s linear infinite;
          }
          @keyframes shiftgen-bar-move {
            from { background-position: 0 0; }
            to { background-position: 28px 0; }
          }
        `}</style>
        <div
          style={{
            background: 'white',
            borderRadius: '20px',
            padding: '40px 56px',
            boxShadow: '0 30px 80px rgba(0,0,0,0.5)',
            minWidth: '420px',
            maxWidth: '92vw',
            textAlign: 'center',
          }}
        >
          <div style={{ marginBottom: '24px' }}>
            <Loader
              size={56}
              style={{ animation: 'shiftgen-spin 1.2s linear infinite', color: '#059669' }}
            />
          </div>
          <h2 style={{ margin: '0 0 12px', fontSize: '22px', color: '#0f172a', fontWeight: 800 }}>
            🚀 シフト自動作成中<span className="shiftgen-dots" />
          </h2>
          <p style={{ margin: '0 0 20px', color: '#475569', fontSize: '14px', lineHeight: 1.6 }}>
            最大 100 回の試行 + 不足修復で 100% 達成を目指します。<br />
            数十秒〜最大 3 分かかる場合があります。
          </p>
          <div
            style={{
              width: '100%',
              height: '14px',
              background: '#e2e8f0',
              borderRadius: '8px',
              overflow: 'hidden',
              marginBottom: '8px',
              position: 'relative',
            }}
          >
            <div
              className="shiftgen-bar-stripe"
              style={{
                width: `${Math.max(progressPercent, 5)}%`,
                height: '100%',
                background: 'linear-gradient(90deg, #10b981, #059669)',
                transition: 'width 0.3s ease',
                backgroundBlendMode: 'overlay',
              }}
            />
          </div>
          <div style={{ fontSize: '14px', color: '#059669', fontWeight: 700, animation: 'shiftgen-pulse 1.4s ease-in-out infinite' }}>
            {progressPercent}% — 計算中
          </div>
          <p style={{ margin: '16px 0 0', color: '#94a3b8', fontSize: '12px' }}>
            このウィンドウは閉じずにお待ちください（CSS アニメーションが止まっていなければ計算は進行中です）
          </p>
        </div>
      </div>
    )}

    {/* ✅ 集中モード */}
    {isFocusMode ? (
      <div style={modernStyles.focusModeContainer}>
         {/* 集中モードヘッダー */}
        <div style={modernStyles.focusModeHeader}>
         <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '12px 20px',
          background: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '12px',
          backdropFilter: 'blur(10px)',
          marginBottom: '12px'
        }}>
  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
    <Calendar size={24} style={{ color: 'white' }} />
    <h1 style={{ margin: 0, fontSize: '20px', fontWeight: '800', color: 'white' }}>
      {`${selectedYear}年${currentMonth}月`}
    </h1>

    {/* 集中モードヘッダー内に追加 */}
<button
  onClick={() => setShowShortcutSettings(true)}
  style={{
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '8px 16px',
    background: 'rgba(139, 92, 246, 0.9)',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '600',
  }}
>
  ⌨️ ショートカット設定
</button>
    
    {/* タブボタン */}
    <div style={{ 
      display: 'flex', 
      gap: '6px',
      background: 'rgba(255,255,255,0.1)',
      padding: '3px',
      borderRadius: '8px'
    }}>
      <button
        onClick={() => setFocusModeTab('hope')}
        style={{
          padding: '8px 16px',
          border: 'none',
          borderRadius: '6px',
          background: focusModeTab === 'hope' 
            ? 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)' 
            : 'transparent',
          color: 'white',
          fontSize: '13px',
          fontWeight: '600',
          cursor: 'pointer',
        }}
      >
        🔧 希望設定
      </button>
      <button
        onClick={() => setFocusModeTab('shift')}
        style={{
          padding: '8px 16px',
          border: 'none',
          borderRadius: '6px',
          background: focusModeTab === 'shift' 
            ? 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)' 
            : 'transparent',
          color: 'white',
          fontSize: '13px',
          fontWeight: '600',
          cursor: 'pointer',
        }}
      >
        📅 シフト確定
      </button>
      
    </div>
    
    {/* 選択情報 */}
    {selectedCells.length > 0 && (
      <div style={{
        padding: '6px 12px',
        background: 'rgba(59, 130, 246, 0.2)',
        borderRadius: '6px',
        color: 'white',
        fontSize: '12px',
        fontWeight: '600'
      }}>
        {selectedCells.length}セル選択中
      </div>
    )}
  </div>
  
  <button
    onClick={() => {
      setIsFocusMode(false);
      setSelectedCells([]);
      setClipboardData([]);
    }}
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      padding: '8px 16px',
      background: 'rgba(239, 68, 68, 0.9)',
      color: 'white',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '13px',
      fontWeight: '600',
    }}
  >
    <XCircle size={16} />
    終了
  </button>
          </div>
        </div>
          {/* シフト表のみ表示 */}
          <div style={modernStyles.focusModeTable}>
          <div style={modernStyles.tableHeader}>
  <Calendar size={24} />
  シフト管理表
  {/* ✅ 職種タブ */}
  <div style={{ marginLeft: '24px', display: 'flex', gap: '8px' }}>
    {jobTypes.map(jt => (
      <button
        key={jt.id}
        onClick={() => setSelectedJobType(jt.id)}
        style={{
          padding: '6px 16px',
          borderRadius: '20px',
          border: 'none',
          cursor: 'pointer',
          fontSize: '13px',
          fontWeight: '700',
          background: selectedJobType === jt.id
            ? 'white'
            : 'rgba(255,255,255,0.2)',
          color: selectedJobType === jt.id ? '#1f2937' : 'white',
          transition: 'all 0.2s ease',
        }}
      >
        {jt.name}
      </button>
    ))}
  </div>
  <div style={{ marginLeft: 'auto', fontSize: '14px', opacity: 0.9 }}>
    {`${selectedYear}年${currentMonth}月`}
  </div>
</div>
            
            <div 
              id="focus-mode-scroll-container"  // ✅ 一意のID
              style={{ 
                overflowX: "scroll",
                overflowY: "scroll",
                maxHeight: "calc(100vh - 180px)",
              }}
            >
              <table style={{ 
                width: "100%",
                minWidth: "1600px",  // ✅ 横スクロール発生用
                borderCollapse: "collapse",
                fontSize: "12px",
                tableLayout: "fixed"
              }}>
    <thead>
      <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0', height: "32px" }}>
        <th style={{
          padding: "6px 8px",
          textAlign: "left",
          fontWeight: "700",
          color: "#374151",
          position: "sticky",
          left: 0,
          top: 0,
          background: "#f8fafc",
          zIndex: 3,
          borderRight: "2px solid #e2e8f0",
          width: "100px",
          fontSize: "12px"
        }}>
          スタッフ名
        </th>
        {dates.map((date) => {
          const isSelectedColumn = selectedCells.some(cell => cell.date === date);
          const dayOfWeek = dayjs(date).day();
          const isHolidayDate = holidays?.includes(date);
          const isSun = dayOfWeek === 0 || isHolidayDate;
          const isSat = dayOfWeek === 6;
          let bg;
          if (isSelectedColumn) {
            bg = focusModeTab === 'hope' ? '#bbf7d0' : '#bfdbfe';
          } else if (isSun) {
            bg = '#fca5a5'; // 飽和した赤（土日列ヘッダー）
          } else if (isSat) {
            bg = '#93c5fd'; // 飽和した青
          } else {
            bg = focusModeTab === 'hope' ? '#f0fdf4' : '#eff6ff';
          }
          const dayColor = isSun ? '#7f1d1d' : isSat ? '#1e3a8a' : '#6b7280';
          return (
            <th key={date} style={{
              padding: "4px 2px",
              textAlign: "center",
              fontWeight: "600",
              color: "#374151",
              width: "40px",
              borderRight: "1px solid #e2e8f0",
              borderLeft: isSun ? '3px solid #ef4444' : isSat ? '3px solid #3b82f6' : undefined,
              position: "sticky",
              top: 0,
              background: bg,
              zIndex: 2,
              fontSize: "10px",
              transition: 'background 0.15s ease'
            }}>
              <div style={{ fontSize: "12px", fontWeight: "700", color: dayColor }}>{dayjs(date).date()}</div>
              <div style={{ fontSize: "9px", fontWeight: "700", color: dayColor }}>
                {["日","月","火","水","木","金","土"][dayOfWeek]}
              </div>
            </th>
          );
        })}
        <th style={{
          padding: "4px",
          textAlign: "center",
          fontWeight: "700",
          color: "#374151",
          width: "100px",
          borderLeft: "3px solid #e2e8f0",
          position: "sticky",
          top: 0,
          background: "#f1f5f9",
          zIndex: 2,
          fontSize: "10px"
        }}>
          集計
        </th>
      </tr>
    </thead>

    <tbody>
    {getFilteredStaffIds().map((empId, index) => {
  const staff = staffList.find(s => s.employeeId === empId);
        const isSelectedRow = selectedCells.some(cell => cell.empId === empId);
        
        return (
          <tr 
            key={empId} 
            style={{ 
              borderBottom: "1px solid #e2e8f0",
              background: index % 2 === 0 ? 'white' : '#f8fafc',
            }}
          >
            <td style={{
              padding: "4px 6px",
              fontWeight: "600",
              color: "#1f2937",
              position: "sticky",
              left: 0,
              zIndex: 1,
              background: isSelectedRow
                ? (focusModeTab === 'hope' ? '#dcfce7' : '#dbeafe')
                : (index % 2 === 0 ? 'white' : '#f8fafc'),
              borderRight: "2px solid #e2e8f0",
              fontSize: "11px",
              transition: 'background 0.15s ease'
            }}>
              {staff ? `${staff.lastName} ${staff.firstName}` : empId}
            </td>

            {dates.map((date) => {
  const key = `${empId}_${date}`;
  const currentValue = focusModeTab === 'hope' 
    ? (hopes[key] || "")
    : (shiftMatrix[key] || "");
  const isSelected = selectedCells.some(cell => 
    cell.empId === empId && cell.date === date
  );
  const isAdminSet = adminHopes[key] !== undefined;
  const showDropdown = dropdownCell === key;

  // ✅ ここに Step 2 のログを追加！
  if (key === "EMP001_2026-02-05") {  // ← テスト用に特定のセルだけログ出力
    console.log("📌 現在のdropdownCell:", dropdownCell);
    console.log("📌 key:", key);
    console.log("📌 showDropdown:", showDropdown);
  }
  
  // 表示ラベル
  let displayLabel = "-";
  if (focusModeTab === 'hope') {
    const option = hopeOptions.find(opt => opt.value === currentValue);
    if (option && option.value) {
      displayLabel = option.label.substring(0, 2);
    }
  } else {
    // ⚠️ 空文字は「未定」として "-" を返す（旧「空=日勤」は廃止済み）
    displayLabel = currentValue === "" ? "-" : currentValue.substring(0, 2);
  }
  
  return (
    <td 
      key={key}
      onClick={(e) => handleCellSelect(empId, date, e.shiftKey, e)}
      style={(() => {
        const dow = dayjs(date).day();
        const isHolDate = holidays?.includes(date);
        const isSun = dow === 0 || isHolDate;
        const isSat = dow === 6;
        let bg;
        if (isSelected) {
          bg = focusModeTab === 'hope' ? '#86efac' : '#93c5fd';
        } else if (focusModeTab === 'hope') {
          bg = isAdminSet ? '#dcfce7' : (isSun ? '#fee2e2' : isSat ? '#dbeafe' : 'white');
        } else {
          bg = isSun ? '#fee2e2' : isSat ? '#dbeafe' : 'white';
        }
        const accent =
          isSelected ? undefined
          : isSun ? 'inset 3px 0 0 #ef4444'
          : isSat ? 'inset 3px 0 0 #3b82f6'
          : undefined;
        return {
          padding: "4px 2px",
          textAlign: "center",
          background: bg,
          cursor: 'pointer',
          transition: 'all 0.1s ease',
          height: "auto",
          verticalAlign: 'top',
          border: isSelected ? '2px solid #3b82f6' : '1px solid #e2e8f0',
          boxShadow: accent,
          position: 'relative',
        };
      })()}
      onMouseEnter={(e) => {
        if (!isSelected) {
          e.currentTarget.style.background = focusModeTab === 'hope' 
            ? '#f0fdf4' 
            : '#eff6ff';
        }
      }}
      onMouseLeave={(e) => {
        if (!isSelected) {
          e.currentTarget.style.background = focusModeTab === 'hope' 
            ? (isAdminSet ? '#dcfce7' : 'white')
            : 'white';
        }
      }}
    >
      {/* セル内容 */}
      <div style={{
        fontSize: "11px",
        fontWeight: isSelected ? "800" : "700",
        color: focusModeTab === 'hope' 
          ? (isSelected ? '#065f46' : '#166534')
          : (isSelected ? '#1e3a8a' : '#1e40af'),
        padding: "4px 0"
      }}>
        {displayLabel}
      </div>
      
      {/* ドロップダウンメニュー: スクロールコンテナ (overflow:scroll) でクリッピング
          されないよう、Portal で body 直下に描画し position:fixed で配置する。
          こうしないと選択肢が外枠を超えると見えなくなる。 */}
      {showDropdown && dropdownAnchor && createPortal(
        <div
          style={{
            position: 'fixed',
            top: dropdownAnchor.top + 4,
            left: dropdownAnchor.left,
            transform: 'translateX(-50%)',
            zIndex: 99999,
            background: 'white',
            border: '2px solid #3b82f6',
            borderRadius: '8px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
            minWidth: '120px',
            maxHeight: '300px',
            overflowY: 'auto'
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {(focusModeTab === 'hope' ? hopeOptions : shiftOptions.map(opt => ({value: opt, label: opt === "" ? "日勤" : opt}))).map((option, idx) => {
            const optionValue = option.value;
            const optionLabel = option.label;
            const isCurrentValue = currentValue === optionValue;

            return (
              <div
                key={idx}
                onClick={() => handleDropdownSelect(empId, date, optionValue)}
                style={{
                  padding: '10px 16px',
                  cursor: 'pointer',
                  background: isCurrentValue
                    ? (focusModeTab === 'hope' ? '#dcfce7' : '#dbeafe')
                    : 'white',
                  borderBottom: idx < (focusModeTab === 'hope' ? hopeOptions.length : shiftOptions.length) - 1
                    ? '1px solid #e5e7eb'
                    : 'none',
                  fontSize: '14px',
                  fontWeight: isCurrentValue ? '700' : '600',
                  color: focusModeTab === 'hope' ? '#166534' : '#1e40af',
                  transition: 'all 0.15s ease'
                }}
                onMouseEnter={(e) => {
                  if (!isCurrentValue) {
                    e.currentTarget.style.background = focusModeTab === 'hope'
                      ? '#f0fdf4'
                      : '#eff6ff';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isCurrentValue) {
                    e.currentTarget.style.background = 'white';
                  }
                }}
              >
                {optionLabel}
                {isCurrentValue && (
                  <span style={{
                    marginLeft: '8px',
                    fontSize: '12px',
                    color: focusModeTab === 'hope' ? '#059669' : '#2563eb'
                  }}>
                    ✓
                  </span>
                )}
              </div>
            );
          })}
        </div>,
        document.body
      )}
    </td>
  );
})}

            <td style={{ 
              padding: "2px",
              backgroundColor: "#f8fafc",
              borderLeft: "3px solid #e2e8f0",
              fontSize: "9px",
              lineHeight: "1.2"
            }}>
              {renderStaffShiftSummaryHorizontal(empId)}
            </td>
          </tr>
        );
      })}
    </tbody>
  </table>
            </div>
          </div>

          {/* ショートカット設定モーダル */}
{showShortcutSettings && (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000,
  }}
  onClick={() => setShowShortcutSettings(false)}
  >
    <div style={{
      background: 'white',
      borderRadius: '16px',
      padding: '32px',
      maxWidth: '600px',
      width: '90%',
      maxHeight: '80vh',
      overflowY: 'auto',
    }}
    onClick={(e) => e.stopPropagation()}
    >
      <h2 style={{ margin: '0 0 24px 0', fontSize: '24px', fontWeight: '700', color: '#1f2937' }}>
        ⌨️ ショートカットキー設定
      </h2>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {/* ✅ 数字キー 0-9（全て同じ扱い） */}
{['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].map(key => (
  <div key={key} style={{
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '16px',
    background: '#f9fafb',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
  }}>
    <div style={{
      width: '48px',
      height: '48px',
      background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
      color: 'white',
      borderRadius: '12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '24px',
      fontWeight: '700',
      boxShadow: '0 4px 12px rgba(139, 92, 246, 0.3)',
    }}>
      {key}
    </div>
    
    <div style={{ flex: 1 }}>
      <select
        value={shortcutKeyMap[key] || ''}
        onChange={(e) => {
          const newMap = { ...shortcutKeyMap, [key]: e.target.value };
          setShortcutKeyMap(newMap);
        }}
        style={{
          width: '100%',
          padding: '12px',
          borderRadius: '8px',
          border: '1px solid #d1d5db',
          fontSize: '16px',
          fontWeight: '600',
          background: 'white',
          color: '#1f2937',
        }}
      >
        <option value="">未設定</option>
        {/* ✅ シフトパターンから動的生成 */}
        {shiftPatterns
          .filter(p => p.isActive !== false)
          .sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0))
          .map((pattern) => {
            const displayMark = pattern.shortName || pattern.displayMark || pattern.name;
            const label = `${pattern.name} (${displayMark})`;
            return (
              <option key={pattern.id} value={displayMark}>
                {label}
              </option>
            );
          })}
        {/* ✅ 休みも追加 */}
        <option value="休">休み (休)</option>
      </select>
    </div>
  </div>
))}
      </div>
      
      <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
        <button
          onClick={() => {
            saveShortcutKeys(shortcutKeyMap);
            setShowShortcutSettings(false);
          }}
          style={{
            flex: 1,
            padding: '14px',
            background: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
          }}
        >
          ✅ 保存
        </button>
        
        <button
          onClick={() => setShowShortcutSettings(false)}
          style={{
            flex: 1,
            padding: '14px',
            background: '#e5e7eb',
            color: '#374151',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
          }}
        >
          キャンセル
        </button>
      </div>
    </div>
  </div>
)}
      </div>
    ) : (
    <div style={modernStyles.container}>
      <Header />
      
      {/* メインコンテンツ（編集モード時は特別なスタイル適用） */}
      <div style={modernStyles.contentWrapper}>
        {/* ヘッダーセクション */}
        <div style={modernStyles.header}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <Calendar size={32} />
              <div>
                <h1 style={{ margin: 0, fontSize: '28px', fontWeight: '800' }}>
                {`${selectedYear}年${currentMonth}月`}
                </h1>
                <p style={{ margin: '4px 0 0 0', fontSize: '16px', opacity: 0.9 }}>
                  シフト作成・管理画面
                  
                </p>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '24px', fontWeight: '700' }}>{statistics.submissionRate}%</div>
              <div style={{ fontSize: '12px', opacity: 0.8 }}>希望提出率</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '24px', fontWeight: '700' }}>{statistics.totalStaff}</div>
              <div style={{ fontSize: '12px', opacity: 0.8 }}>総スタッフ数</div>
            </div>
            {/* ✅ 管理者設定件数のみ表示（未保存条件を削除） */}
            {statistics.adminHopeCount > 0 && (
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '24px', fontWeight: '700', color: '#16a34a' }}>{statistics.adminHopeCount}</div>
                <div style={{ fontSize: '12px', opacity: 0.8 }}>管理者設定</div>
              </div>
            )}
          </div>
          </div>
        </div>

        {/* 順序編集モード表示バナー */}
{isOrderEditMode && (
  <div style={{
    ...modernStyles.hopeEditModeSimple,
    background: hasOrderChanges 
      ? 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)'
      : 'linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)',
    border: hasOrderChanges 
      ? '2px solid #f59e0b'
      : '2px solid #7c3aed',
    boxShadow: hasOrderChanges 
      ? '0 4px 15px rgba(245, 158, 11, 0.2)'
      : '0 4px 15px rgba(124, 58, 237, 0.2)',
  }}>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <Users size={24} style={{ 
          color: hasOrderChanges ? '#d97706' : '#7c3aed' 
        }} />
        <h3 style={{ 
          margin: 0, 
          color: hasOrderChanges ? '#92400e' : '#5b21b6', 
          fontSize: '18px', 
          fontWeight: '700' 
        }}>
          スタッフ順序編集モード
          {hasOrderChanges && (
            <span style={{ 
              marginLeft: '8px', 
              fontSize: '14px', 
              color: '#d97706',
              fontWeight: '600'
            }}>
              (未保存の変更あり)
            </span>
          )}
        </h3>
      </div>
      <div style={{ display: 'flex', gap: '8px' }}>
        {hasOrderChanges && (
          <button
            onClick={saveCustomStaffOrder}
            disabled={savingOrder}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 16px',
              border: 'none',
              borderRadius: '8px',
              background: savingOrder 
                ? '#9ca3af' 
                : 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
              color: 'white',
              fontSize: '14px',
              fontWeight: '600',
              cursor: savingOrder ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s ease-in-out',
            }}
          >
            {savingOrder ? (
              <Loader size={16} style={{ animation: 'spin 2s linear infinite' }} />
            ) : (
              <Save size={16} />
            )}
            {savingOrder ? '保存中...' : '保存'}
          </button>
        )}
        
      </div>
    </div>
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', alignItems: 'center' }}>
      <div style={{ 
        padding: "8px 16px", 
        background: hasOrderChanges 
          ? 'rgba(245, 158, 11, 0.2)' 
          : 'rgba(124, 58, 237, 0.2)', 
        borderRadius: "12px", 
        fontSize: "14px",
        fontWeight: '600',
        color: hasOrderChanges ? '#92400e' : '#5b21b6',
        border: hasOrderChanges 
          ? '1px solid rgba(245, 158, 11, 0.3)'
          : '1px solid rgba(124, 58, 237, 0.3)'
      }}>
        🔄 スタッフ行をドラッグ&ドロップで移動
      </div>
      <div style={{ 
        padding: "8px 16px", 
        background: hasOrderChanges 
          ? 'rgba(245, 158, 11, 0.2)' 
          : 'rgba(124, 58, 237, 0.2)', 
        borderRadius: "12px", 
        fontSize: "14px",
        fontWeight: '600',
        color: hasOrderChanges ? '#92400e' : '#5b21b6',
        border: hasOrderChanges 
          ? '1px solid rgba(245, 158, 11, 0.3)'
          : '1px solid rgba(124, 58, 237, 0.3)'
      }}>
        👑 役職者を上位に配置可能
      </div>
      <div style={{ 
        padding: "8px 16px", 
        background: hasOrderChanges 
          ? 'rgba(245, 158, 11, 0.2)' 
          : 'rgba(124, 58, 237, 0.2)', 
        borderRadius: "12px", 
        fontSize: "14px",
        fontWeight: '600',
        color: hasOrderChanges ? '#92400e' : '#5b21b6',
        border: hasOrderChanges 
          ? '1px solid rgba(245, 158, 11, 0.3)'
          : '1px solid rgba(124, 58, 237, 0.3)'
      }}>
        💾 月別でカスタム順序を保存
      </div>
    </div>
  </div>
)}

        {/* 月切り替え */}
        <div style={modernStyles.monthSelector}>
        <button 
  onClick={() => {
    if (currentMonth === 1) {
      setCurrentMonth(12);
      setSelectedYear(selectedYear - 1);
    } else {
      setCurrentMonth(currentMonth - 1);
    }
  }}
  style={modernStyles.monthButton}
  onMouseEnter={(e) => {
    e.target.style.transform = 'translateY(-2px)';
    e.target.style.boxShadow = '0 6px 20px rgba(249, 115, 22, 0.4)';
  }}
  onMouseLeave={(e) => {
    e.target.style.transform = 'translateY(0)';
    e.target.style.boxShadow = '0 4px 15px rgba(249, 115, 22, 0.3)';
  }}
>
  <ChevronLeft size={18} />
  前月
</button>
          
          <div style={{ 
            fontSize: '32px', 
            fontWeight: '800', 
            color: '#1f2937',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>
            {currentMonth}月
          </div>
          
          <button 
            onClick={() => {
              if (currentMonth === 12) {
                setCurrentMonth(1);
                setSelectedYear(selectedYear + 1);
              } else {
                setCurrentMonth(currentMonth + 1);
              }
            }}
            style={modernStyles.monthButton}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 20px rgba(249, 115, 22, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 15px rgba(249, 115, 22, 0.3)';
            }}
          >
            翌月
            <ChevronRight size={18} />
          </button>
        </div>

        {/* 日勤のみスタッフ設定 */}
        <DayShiftOnlyPanel />

        {/* 自動割り当て対象外スタッフの表示 */}
        {excludedStaff.length > 0 && (
          <div style={modernStyles.alertCard}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
              <Info size={24} style={{ color: '#f59e0b' }} />
              <h3 style={{ margin: 0, color: '#92400e', fontSize: '18px', fontWeight: '700' }}>
                自動割り当て対象外のスタッフ
              </h3>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginBottom: '16px' }}>
              {excludedStaff.map(staff => (
                <div key={staff.id} style={{ 
                  padding: "8px 16px", 
                  background: 'rgba(251, 191, 36, 0.2)', 
                  borderRadius: "20px", 
                  fontSize: "14px",
                  fontWeight: '600',
                  color: '#92400e',
                  border: '1px solid rgba(251, 191, 36, 0.3)'
                }}>
                  {staff.lastName} {staff.firstName}
                </div>
              ))}
            </div>
            <p style={{ margin: 0, fontSize: '14px', color: '#78716c', lineHeight: '1.5' }}>
              これらのスタッフは固定シフトパターンが適用され、自動割り当て処理から除外されます
            </p>
          </div>
        )}

        {/* ===== シフト公開状態バナー ===== */}
<div style={{
  background: isPublished ? '#dcfce7' : '#fef3c7',
  border: `1.5px solid ${isPublished ? '#16a34a' : '#f59e0b'}`,
  borderRadius: 10,
  padding: '12px 16px',
  marginBottom: 16,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 12,
  flexWrap: 'wrap',
}}>
  <div style={{ fontSize: 14, color: isPublished ? '#166534' : '#92400e' }}>
    <strong>{selectedYear}年{currentMonth}月のシフト:</strong>{' '}
    {isPublished
      ? '✅ 公開中 (スタッフのホーム・カレンダーに表示されます)'
      : '📝 下書き (スタッフにはまだ表示されていません)'}
  </div>
  <div style={{ display: 'flex', gap: 8 }}>
    {isPublished ? (
      <button
        type="button"
        onClick={handleUnpublishShift}
        disabled={publishing}
        style={{
          padding: '8px 16px',
          background: publishing ? '#9ca3af' : '#fff',
          color: publishing ? '#fff' : '#92400e',
          border: '1.5px solid #f59e0b',
          borderRadius: 6,
          fontWeight: 700,
          fontSize: 13,
          cursor: publishing ? 'not-allowed' : 'pointer',
        }}
      >
        {publishing ? '処理中...' : '下書きに戻す'}
      </button>
    ) : (
      <button
        type="button"
        onClick={handlePublishShift}
        disabled={publishing}
        style={{
          padding: '8px 20px',
          background: publishing ? '#9ca3af' : 'linear-gradient(135deg, #16a34a, #15803d)',
          color: 'white',
          border: 'none',
          borderRadius: 6,
          fontWeight: 700,
          fontSize: 13,
          cursor: publishing ? 'not-allowed' : 'pointer',
          boxShadow: publishing ? 'none' : '0 2px 8px rgba(22, 163, 74, 0.3)',
        }}
      >
        {publishing ? '処理中...' : '📢 シフトを公開する'}
      </button>
    )}
  </div>
</div>

        {/* アクションカードグリッド */}
<div style={modernStyles.actionGrid}>

{/* ✅ 集中モードカード */}
<div 
  style={modernStyles.actionCard}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'translateY(-4px)';
    e.currentTarget.style.boxShadow = '0 12px 35px rgba(0, 0, 0, 0.15)';
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = 'translateY(0)';
    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.1)';
  }}
>
  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
    <Eye size={24} style={{ color: '#0891b2' }} />
    <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '700', color: '#1f2937' }}>
      集中モード
    </h3>
  </div>
  <p style={{ margin: '0 0 20px 0', color: '#6b7280', fontSize: '14px', lineHeight: '1.5' }}>
    シフト表を全画面表示して作業に集中できます
  </p>
  <button
    onClick={() => setIsFocusMode(true)}
    style={{
      ...modernStyles.primaryButton,
      background: 'linear-gradient(135deg, #0891b2 0%, #0e7490 100%)',
      color: 'white',
      fontSize: '14px',
      padding: '10px 16px',
      cursor: 'pointer',
    }}
  >
    <Eye size={16} />
    集中モードを開始
  </button>
</div>



{/* 特定日の必要人数オーバーライドカード */}
<div
  style={modernStyles.actionCard}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'translateY(-4px)';
    e.currentTarget.style.boxShadow = '0 12px 35px rgba(0, 0, 0, 0.15)';
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = 'translateY(0)';
    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.1)';
  }}
>
  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
    <Calendar size={24} style={{ color: '#0891b2' }} />
    <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '700', color: '#1f2937' }}>
      特定日の必要人数
    </h3>
  </div>
  <p style={{ margin: '0 0 20px 0', color: '#6b7280', fontSize: '14px', lineHeight: '1.5' }}>
    通常の曜日設定を上書きして、特定日だけパターン別の必要人数を変更できます。
    自動シフト作成・集計表示の両方に反映されます。
  </p>
  <button
    onClick={() => setShowDailyOverrideModal(true)}
    style={{
      ...modernStyles.primaryButton,
      background: 'linear-gradient(135deg, #0891b2 0%, #0e7490 100%)',
      color: 'white',
      boxShadow: '0 8px 20px rgba(8, 145, 178, 0.3)',
      cursor: 'pointer',
      width: '100%',
    }}
  >
    <Calendar size={18} />
    オーバーライド設定を開く
  </button>

  {monthlyOverrides && monthlyOverrides.length > 0 && (
    <div style={{ marginTop: '14px', borderTop: '1px solid #e5e7eb', paddingTop: '12px' }}>
      <div style={{ fontSize: '12px', fontWeight: 700, color: '#0891b2', marginBottom: '8px' }}>
        当月の設定済み日（{monthlyOverrides.length}件）
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', maxHeight: '120px', overflowY: 'auto' }}>
        {monthlyOverrides.map((ov) => {
          const count = Object.keys(ov.required_counts || {}).length;
          return (
            <button
              key={ov.override_date}
              onClick={() => setShowDailyOverrideModal(true)}
              title={ov.note || `${count}パターン上書き`}
              style={{
                padding: '4px 10px',
                background: '#ecfeff',
                border: '1px solid #67e8f9',
                borderRadius: '14px',
                fontSize: '12px',
                color: '#0e7490',
                fontWeight: 600,
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
              }}
            >
              <span>{dayjs(ov.override_date).format('M/D')}</span>
              <span style={{ fontSize: '10px', color: '#0891b2', fontWeight: 500 }}>
                {count}P
              </span>
              {ov.note && (
                <span style={{ fontSize: '10px', color: '#475569', maxWidth: '90px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {ov.note}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  )}
</div>

{/* 係活動・イベントカード */}
<div
  style={modernStyles.actionCard}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'translateY(-4px)';
    e.currentTarget.style.boxShadow = '0 12px 35px rgba(0, 0, 0, 0.15)';
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = 'translateY(0)';
    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.1)';
  }}
>
  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
    <Calendar size={24} style={{ color: '#10b981' }} />
    <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '700', color: '#1f2937' }}>
      係活動・イベント
    </h3>
  </div>
  <p style={{ margin: '0 0 20px 0', color: '#6b7280', fontSize: '14px', lineHeight: '1.5' }}>
    係活動など特定日に「スキルグループ全員を特定の勤務に強制配置」するイベントをカレンダーから登録。自動シフト作成にも反映されます。
  </p>
  <button
    onClick={() => setShowRecurringEventModal(true)}
    style={{
      ...modernStyles.primaryButton,
      background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
      color: 'white',
      boxShadow: '0 8px 20px rgba(16, 185, 129, 0.3)',
      cursor: 'pointer',
      width: '100%',
    }}
  >
    <Calendar size={18} />
    イベント管理を開く
  </button>
</div>

{/* 自動割り当てカード */}
<div
  style={modernStyles.actionCard}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'translateY(-4px)';
    e.currentTarget.style.boxShadow = '0 12px 35px rgba(0, 0, 0, 0.15)';
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = 'translateY(0)';
    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.1)';
  }}
>
  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
    <RotateCcw size={24} style={{ color: '#059669' }} />
    <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '700', color: '#1f2937' }}>
      自動割り当て
    </h3>
  </div>
  <p style={{ margin: '0 0 20px 0', color: '#6b7280', fontSize: '14px', lineHeight: '1.5' }}>
    希望とパターンから最適なシフトを自動生成（職種ごとに分けて実行できます）
  </p>
  <button
    onClick={() => handleAutoAssignment(null)}
    disabled={isLoading}
    style={{
      ...modernStyles.primaryButton,
      background: isLoading ? '#9ca3af' : 'linear-gradient(135deg, #059669 0%, #047857 100%)',
      color: 'white',
      boxShadow: isLoading ? 'none' : '0 8px 20px rgba(5, 150, 105, 0.3)',
      cursor: isLoading ? 'not-allowed' : 'pointer',
      marginBottom: '12px',
      width: '100%',
    }}
  >
    {isLoading ? <Loader size={18} style={{ animation: 'spin 2s linear infinite' }} /> : <RotateCcw size={18} />}
    {isLoading ? `処理中... ${progressPercent}%` : "全職種で自動割り当て"}
  </button>
  {/* 🧪 V2 試算ボタン: 既存 V1 と並列、別フロー。 保存はされない。 */}
  <button
    onClick={() => setV2TrialOpen(true)}
    disabled={isLoading}
    style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
      padding: '10px 16px',
      marginBottom: '12px',
      width: '100%',
      border: '1.5px dashed #1d4ed8',
      borderRadius: 10,
      background: 'white',
      color: '#1d4ed8',
      fontSize: 13,
      fontWeight: 700,
      cursor: isLoading ? 'not-allowed' : 'pointer',
      opacity: isLoading ? 0.6 : 1,
    }}
    title="新しい V2 エンジン (CP-SAT) で試算します。 結果は画面に表示するだけで、DB には保存されません"
  >
    🧪 V2 試算 (保存なし)
  </button>
  {jobTypes && jobTypes.length > 0 && (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '8px' }}>
      <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '600' }}>
        または職種ごとに実行:
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
        {jobTypes.map((jt) => (
          <button
            key={jt.id}
            onClick={() => handleAutoAssignment(jt.id)}
            disabled={isLoading}
            style={{
              padding: '8px 14px',
              borderRadius: '8px',
              border: '1px solid #d1d5db',
              background: isLoading ? '#f3f4f6' : '#ffffff',
              color: isLoading ? '#9ca3af' : '#374151',
              fontSize: '13px',
              fontWeight: '600',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              if (!isLoading) {
                e.currentTarget.style.background = '#ecfdf5';
                e.currentTarget.style.borderColor = '#059669';
                e.currentTarget.style.color = '#047857';
              }
            }}
            onMouseLeave={(e) => {
              if (!isLoading) {
                e.currentTarget.style.background = '#ffffff';
                e.currentTarget.style.borderColor = '#d1d5db';
                e.currentTarget.style.color = '#374151';
              }
            }}
          >
            {jt.name}で実行
          </button>
        ))}
      </div>
    </div>
  )}
</div>

{/* データ出力カード */}
<div 
  style={modernStyles.actionCard}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'translateY(-4px)';
    e.currentTarget.style.boxShadow = '0 12px 35px rgba(0, 0, 0, 0.15)';
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = 'translateY(0)';
    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.1)';
  }}
>
  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
    <Download size={24} style={{ color: '#7c3aed' }} />
    <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '700', color: '#1f2937' }}>
      確定シフト出力
    </h3>
  </div>
  <p style={{ margin: '0 0 20px 0', color: '#6b7280', fontSize: '14px', lineHeight: '1.5' }}>
    シフト表をCSV形式でダウンロード
  </p>
  <button
    onClick={handleCSVDownload}
    style={{
      ...modernStyles.primaryButton,
      background: 'linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%)',
      color: 'white',
      boxShadow: '0 8px 20px rgba(124, 58, 237, 0.3)',
      cursor: 'pointer',
    }}
  >
    <Download size={18} />
    シフト表CSV出力
  </button>
</div>

{/* データ出力カード */}
<div 
  style={modernStyles.actionCard}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'translateY(-4px)';
    e.currentTarget.style.boxShadow = '0 12px 35px rgba(0, 0, 0, 0.15)';
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = 'translateY(0)';
    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.1)';
  }}
>
  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
    <Download size={24} style={{ color: '#7c3aed' }} />
    <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '700', color: '#1f2937' }}>
      シフト希望出力
    </h3>
  </div>
  <p style={{ margin: '0 0 20px 0', color: '#6b7280', fontSize: '14px', lineHeight: '1.5' }}>
    シフト希望をCSV形式でダウンロード
  </p>
  <button
    onClick={handleHopeCSVDownload}
    style={{
      ...modernStyles.primaryButton,
      background: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
      color: 'white',
      boxShadow: '0 8px 20px rgba(22, 163, 74, 0.3)',
      cursor: 'pointer',
    }}
  >
    <Download size={18} />
    希望CSV出力
  </button>
</div>


{/* 通知・チェックカード */}
<div 
  style={modernStyles.actionCard}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'translateY(-4px)';
    e.currentTarget.style.boxShadow = '0 12px 35px rgba(0, 0, 0, 0.15)';
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = 'translateY(0)';
    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.1)';
  }}
>
  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
    <Mail size={24} style={{ color: '#dc2626' }} />
    <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '700', color: '#1f2937' }}>
      通知・チェック
    </h3>
  </div>
  <p style={{ margin: '0 0 20px 0', color: '#6b7280', fontSize: '14px', lineHeight: '1.5' }}>
    リマインダー送信や希望重複をチェックします
  </p>
  <div style={{ display: 'flex', gap: '8px' }}>
    <button
      onClick={handleSendReminders}
      style={{
        ...modernStyles.primaryButton,
        background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
        color: 'white',
        fontSize: '14px',
        padding: '10px 16px',
        flex: 1,
        cursor: 'pointer',
      }}
    >
      <Mail size={16} />
      催促
    </button>
    <button
      onClick={() => {/* handleCheckConflicts */}}
      style={{
        ...modernStyles.primaryButton,
        background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
        color: 'white',
        fontSize: '14px',
        padding: '10px 16px',
        flex: 1,
        cursor: 'pointer',
      }}
    >
      <Search size={16} />
      重複
    </button>
  </div>
  </div>

</div>  {/* ✅ ここで actionGrid を閉じる */}

        

        {/* 順序編集モード時の統計 */}



       {/* 凡例（簡略化版） */}
<div style={modernStyles.legendContainer}>
  <div style={{ ...modernStyles.legendItem, background: '#dcfce7' }}>
    <div style={{ width: "12px", height: "12px", backgroundColor: '#dcfce7', borderRadius: '50%', border: "1px solid #16a34a" }}></div>
    <span>🔧 希望設定エリア（緑）</span>
  </div>
  <div style={{ ...modernStyles.legendItem, background: '#dbeafe' }}>
    <div style={{ width: "12px", height: "12px", backgroundColor: '#dbeafe', borderRadius: '50%', border: "1px solid #3b82f6" }}></div>
    <span>📅 シフト確定エリア（青）</span>
  </div>
  <div style={{ ...modernStyles.legendItem, background: '#fee2e2' }}>
    <div style={{ width: "12px", height: "12px", backgroundColor: '#ffebee', borderRadius: '50%', border: "1px solid #f87171" }}></div>
    <span>希望未提出スタッフ</span>
  </div>
  <div style={{ ...modernStyles.legendItem, background: '#fff3e0' }}>
    <div style={{ width: "12px", height: "12px", backgroundColor: '#fff3e0', borderRadius: '50%', border: "1px solid #f59e0b" }}></div>
    <span>自動割り当て対象外</span>
  </div>

  {statistics.adminHopeCount > 0 && (
    <div style={{ ...modernStyles.legendItem, background: '#f0fdf4', border: '1px solid #16a34a' }}>
      <div style={{ width: "12px", height: "12px", backgroundColor: "#f0fdf4", borderRadius: '50%', border: "2px solid #16a34a" }}></div>
      <span style={{ fontWeight: '600' }}>
        🔧 管理者設定済み ({statistics.adminHopeCount}件)
      </span>
    </div>
  )}
  
  {/* ✅ isOrderEditModeをlegendContainerの内側に移動 */}
  {isOrderEditMode && (
    <div style={{ ...modernStyles.legendItem, background: '#e0e7ff', border: '1px solid #7c3aed' }}>
      <div style={{ width: "12px", height: "12px", backgroundColor: "#e0e7ff", borderRadius: '50%', border: "2px solid #7c3aed" }}></div>
      <span style={{ fontWeight: '600' }}>
        🔄 順序編集モード - ドラッグ&ドロップで移動
        {hasOrderChanges && (
          <span style={{ color: '#f59e0b', fontWeight: '700', marginLeft: '4px' }}>
            (未保存)
          </span>
        )}
      </span>
    </div>
  )}
</div>  {/* ✅ ここでlegendContainerを閉じる */}

{/* シフト表 - 編集モード時も操作可能 */}
<div style={modernStyles.tableContainer}>
          <div style={modernStyles.tableHeader}>
  <Calendar size={24} />
  シフト管理表
  {/* ✅ 職種タブ */}
  <div style={{ marginLeft: '24px', display: 'flex', gap: '8px' }}>
    {jobTypes.map(jt => (
      <button
        key={jt.id}
        onClick={() => setSelectedJobType(jt.id)}
        style={{
          padding: '6px 16px',
          borderRadius: '20px',
          border: 'none',
          cursor: 'pointer',
          fontSize: '13px',
          fontWeight: '700',
          background: selectedJobType === jt.id
            ? 'white'
            : 'rgba(255,255,255,0.2)',
          color: selectedJobType === jt.id ? '#1f2937' : 'white',
          transition: 'all 0.2s ease',
        }}
      >
        {jt.name}
      </button>
    ))}
  </div>
  <div style={{ marginLeft: 'auto', fontSize: '14px', opacity: 0.9 }}>
    {`${selectedYear}年${currentMonth}月`}
  </div>
</div>
          
          <div style={{ overflowX: "auto", maxHeight: "70vh" }}>
            <table style={{ 
              width: "100%",
              borderCollapse: "collapse",
              minWidth: "1200px",
              fontSize: "14px"
            }}>
              <thead>
                <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                  <th style={{
                    padding: "16px",
                    textAlign: "left",
                    fontWeight: "700",
                    color: "#374151",
                    position: "sticky",
                    left: 0,
                    top: 0,
                    background: "#f8fafc",
                    zIndex: 3,
                    borderRight: "2px solid #e2e8f0",
                    boxShadow: "2px 0 4px rgba(0,0,0,0.1)"
                  }}>
                    スタッフ名
                  </th>
                  {dates.map((date) => {
                    const dayOfWeek = dayjs(date).day();
                    const isHolidayDate = holidays?.includes(date);
                    const isSun = dayOfWeek === 0 || isHolidayDate;
                    const isSat = dayOfWeek === 6;
                    const bg = isSun ? '#fca5a5' : isSat ? '#93c5fd' : '#f8fafc';
                    const dayColor = isSun ? '#7f1d1d' : isSat ? '#1e3a8a' : '#6b7280';
                    const accent = isSun
                      ? 'inset 4px 0 0 #dc2626, 0 2px 4px rgba(0,0,0,0.1)'
                      : isSat
                        ? 'inset 4px 0 0 #2563eb, 0 2px 4px rgba(0,0,0,0.1)'
                        : '0 2px 4px rgba(0,0,0,0.1)';
                    return (
                      <th key={date} style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "700",
                        color: "#374151",
                        minWidth: "80px",
                        borderRight: "1px solid #e2e8f0",
                        position: "sticky",
                        top: 0,
                        background: bg,
                        zIndex: 2,
                        boxShadow: accent,
                      }}>
                        <div style={{ color: dayColor, fontSize: "16px", fontWeight: 800 }}>{dayjs(date).date()}</div>
                        <div style={{ fontSize: "11px", color: dayColor, fontWeight: 700 }}>
                          {["日","月","火","水","木","金","土"][dayOfWeek]}
                        </div>
                      </th>
                    );
                  })}
                  <th style={{
                    padding: "12px 8px",
                    textAlign: "center",
                    fontWeight: "700",
                    color: "#374151",
                    minWidth: "200px",
                    borderLeft: "3px solid #e2e8f0",
                    position: "sticky",
                    top: 0,
                    background: "#f1f5f9",
                    zIndex: 2,
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                      <Activity size={16} />
                      シフト集計
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody>
              {getFilteredStaffIds().map((empId, index) => {
  const hasSubmitted = submittedStaffIds.has(empId);
  const isExcluded = staffList.find(s => s.id === empId)?.excludeFromAutoAssign;  // ✅
  const staff = staffList.find(s => s.employeeId === empId);
    
    // 🔥 最大連続勤務日数を計算
    const consecutiveInfo = calculateMaxConsecutiveDays(empId, dates, shiftMatrix, shiftPatterns, priorMonthMatrix);
    const maxConsecutiveWorkDays = settings?.maxConsecutiveWorkDays || 6;
    
    // 🔥 連勤数に応じたスタイルを決定
    const getConsecutiveStyle = () => {
      if (consecutiveInfo.max > maxConsecutiveWorkDays) {
        return modernStyles.dangerConsecutive;
      } else if (consecutiveInfo.max >= maxConsecutiveWorkDays - 1) {
        return modernStyles.warningConsecutive;
      } else {
        return modernStyles.normalConsecutive;
      }
    };
    
    // ドラッグ&ドロップの視覚的フィードバック
    const isDraggedRow = draggedStaffId === empId;
    const isDragOverRow = dragOverIndex === index;
    
    return (
      <tr 
        key={empId} 
        style={{ 
          borderBottom: "1px solid #e2e8f0",
          background: index % 2 === 0 ? 'white' : '#f8fafc',
        }}
      >
        <td style={{
  padding: "16px",
  fontWeight: "600",
  color: "#1f2937",
  background: isExcluded ? "#fff7ed" : hasSubmitted ? "white" : "#fef2f2",
  position: "sticky",
  left: 0,
  zIndex: 1,
  borderRight: "2px solid #e2e8f0",
  minWidth: "200px",
  boxShadow: "2px 0 4px rgba(0,0,0,0.05)",
}}>
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    {/* 順序変更ボタン */}
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      gap: '2px',
      marginRight: '4px'
    }}>
      {/* 上へボタン */}
      <button
        onClick={() => moveStaffUp(empId)}
        disabled={index === 0}
        style={{
          width: '20px',
          height: '20px',
          border: '1px solid #d1d5db',
          borderRadius: '4px',
          background: index === 0 ? '#f3f4f6' : 'white',
          cursor: index === 0 ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: index === 0 ? 0.3 : 1,
          transition: 'all 0.2s ease-in-out',
        }}
        onMouseEnter={(e) => {
          if (index !== 0) {
            e.target.style.background = '#e0f7fa';
            e.target.style.borderColor = '#0891b2';
          }
        }}
        onMouseLeave={(e) => {
          if (index !== 0) {
            e.target.style.background = 'white';
            e.target.style.borderColor = '#d1d5db';
          }
        }}
        title="上へ移動"
      >
        <ChevronUp size={12} color={index === 0 ? '#9ca3af' : '#0891b2'} />
      </button>
      
      {/* 下へボタン */}
      <button
        onClick={() => moveStaffDown(empId)}
        disabled={index === getSortedStaffIds(staffList, customStaffOrder).length - 1}
        style={{
          width: '20px',
          height: '20px',
          border: '1px solid #d1d5db',
          borderRadius: '4px',
          background: index === getSortedStaffIds(staffList, customStaffOrder).length - 1 ? '#f3f4f6' : 'white',
          cursor: index === getSortedStaffIds(staffList, customStaffOrder).length - 1 ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: index === getSortedStaffIds(staffList, customStaffOrder).length - 1 ? 0.3 : 1,
          transition: 'all 0.2s ease-in-out',
        }}
        onMouseEnter={(e) => {
          if (index !== getSortedStaffIds(staffList, customStaffOrder).length - 1) {
            e.target.style.background = '#e0f7fa';
            e.target.style.borderColor = '#0891b2';
          }
        }}
        onMouseLeave={(e) => {
          if (index !== getSortedStaffIds(staffList, customStaffOrder).length - 1) {
            e.target.style.background = 'white';
            e.target.style.borderColor = '#d1d5db';
          }
        }}
        title="下へ移動"
      >
        <ChevronDown size={12} color={index === getSortedStaffIds(staffList, customStaffOrder).length - 1 ? '#9ca3af' : '#0891b2'} />
      </button>
    </div>
    
    <div style={{ flex: 1 }}>
      <div style={{ marginBottom: '4px', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span>{staff ? `${staff.lastName} ${staff.firstName}` : empId}</span>
        
        {/* 順序番号表示 */}
        {customStaffOrder.length > 0 && customStaffOrder.includes(empId) && (
          <span style={{
            fontSize: '10px',
            color: '#7c3aed',
            background: '#f5f3ff',
            padding: '2px 6px',
            borderRadius: '10px',
            border: '1px solid #e9d5ff',
            fontWeight: '600'
          }}>
            #{customStaffOrder.indexOf(empId) + 1}
          </span>
        )}
      </div>
      
      {isExcluded && (
        <div style={{
          ...modernStyles.statusBadge,
          background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
          fontSize: '10px',
          padding: '2px 8px',
        }}>
          <AlertTriangle size={10} />
          対象外
        </div>
      )}
      {!hasSubmitted && !isExcluded && (
        <div style={{
          ...modernStyles.statusBadge,
          background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
          fontSize: '10px',
          padding: '2px 8px',
        }}>
          <XCircle size={10} />
          未提出
        </div>
      )}
      
      {/* 最大連勤数表示 */}
      {consecutiveInfo.max > 0 && (
        <div style={{
          ...modernStyles.consecutiveBadge,
          ...getConsecutiveStyle(),
        }}>
          <TrendingUp size={10} />
          <span>最大{Number.isInteger(consecutiveInfo.max) ? consecutiveInfo.max : consecutiveInfo.max.toFixed(1)}連勤</span>
          {consecutiveInfo.max > maxConsecutiveWorkDays && (
            <AlertCircle size={10} />
          )}
        </div>
      )}
    </div>
  </div>
</td>

        {/* 既存の日付セル部分はそのまま維持 */}
        {dates.map((date, dateIndex) => {
  const key = `${empId}_${date}`;
  const hopeStatus = getHopeStatus(empId, date);
  
  // 最大連勤期間内かチェック
  const isMaxConsecutive = dateIndex >= consecutiveInfo.start && 
                           dateIndex <= consecutiveInfo.end && 
                           consecutiveInfo.max > 0;
  
  // 土日・祝日の判定（背景色 + 左帯の両方に使用）
  const dowMain = dayjs(date).day();
  const isHolDateMain = holidays?.includes(date);
  const isSunMain = dowMain === 0 || isHolDateMain;
  const isSatMain = dowMain === 6;

  let bg = "#ffffff";

  if (isExcluded) {
    bg = "#fff7ed";
  } else if (!hasSubmitted) {
    bg = "#fef2f2";
  } else if (isMaxConsecutive && consecutiveInfo.max > maxConsecutiveWorkDays) {
    bg = "#fee2e2";
  } else if (isSunMain) {
    bg = "#fee2e2";
  } else if (isSatMain) {
    bg = "#dbeafe";
  }

  // 左辺の太い色帯（土曜=青、日曜=赤）。連勤警告の inset shadow と共存させる。
  const weekendAccent = isSunMain
    ? 'inset 4px 0 0 #ef4444'
    : isSatMain
      ? 'inset 4px 0 0 #3b82f6'
      : '';
  
  return (
    <td key={key} style={{ 
      padding: "4px",
      textAlign: "center",
      backgroundColor: bg,
      borderRight: "1px solid #e2e8f0",
      position: "relative",
      boxShadow: [
        isMaxConsecutive && consecutiveInfo.max > maxConsecutiveWorkDays
          ? '0 0 0 2px rgba(239, 68, 68, 0.3) inset'
          : '',
        weekendAccent,
      ].filter(Boolean).join(', ') || 'none',
      verticalAlign: 'top',
    }}>
      {/* 最大連勤インジケーター */}
      {isMaxConsecutive && consecutiveInfo.max > maxConsecutiveWorkDays && (
        <div style={{
          position: 'absolute',
          top: '2px',
          left: '2px',
          width: '14px',
          height: '14px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
        }}>
          <TrendingUp size={8} color="white" />
        </div>
      )}
      
      {/* 🔥 上段：希望編集エリア（緑背景） */}
<div style={{
  background: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)',
  border: '1px solid #86efac',
  borderRadius: '6px',
  padding: '6px 4px',
  marginBottom: '4px',
}}>
  <div style={{ 
    fontSize: '9px', 
    color: '#166534', 
    fontWeight: '700',
    marginBottom: '4px',
    textAlign: 'center',
  }}>
    🔧 希望設定
  </div>

  {/* コメントマーク */}
{shiftComments[key] && (
  <div
    title={shiftComments[key]}
    style={{
      position: 'absolute',
      top: '4px',
      right: '4px',
      width: '16px',
      height: '16px',
      borderRadius: '50%',
      background: '#f59e0b',
      color: 'white',
      fontSize: '10px',
      fontWeight: '700',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'help',
      zIndex: 2,
      boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    }}
  >
    💬
  </div>
)}
  
  {/* 希望編集セレクター */}
  <select
    value={hopes[key] || ""}
    onChange={(e) => handleAdminHopeChange(empId, date, e.target.value)}
    style={{
      width: '100%',
      padding: '10px 8px',
      borderRadius: '8px',
      border: adminHopes[key] !== undefined 
        ? `2px solid ${getCurrentHopeColor(key)}`  // ✅ 動的な枠線色
        : '1px solid #86efac',
      fontSize: '18px',  // ✅ フォントサイズ拡大
      background: 'white',
      color: getCurrentHopeColor(key),  // ✅ 動的な文字色
      fontWeight: '700',  // ✅ 太字
      cursor: 'pointer',
      lineHeight: '1.8',
      minHeight: '42px',
      textAlign: 'center',  // ✅ 中央揃え
    }}
  >
    {hopeOptions.map((option, index) => (
      <option 
        key={`hope-${index}-${option.value}`} 
        value={option.value}
        style={{
          color: option.color,  // これはブラウザによって効かない場合がある
        }}
      >
        {option.label}
      </option>
    ))}
  </select>
  
  {/* 希望の出典表示 */}
  <div style={{ 
    fontSize: '8px', 
    color: getCurrentHopeColor(key),  // ✅ 動的な文字色
    marginTop: '3px',
    textAlign: 'center',
    fontWeight: '600',
  }}>
    {adminHopes[key] !== undefined ? (
      <span>🔧 管理者</span>
    ) : originalHopes[key] ? (
      <span>👤 個人</span>
    ) : (
      <span style={{ color: '#9ca3af' }}>未設定</span>
    )}
  </div>
</div>
      
      {/* 🔥 下段：シフト入力エリア（青背景） */}
      <div style={{
        background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
        border: '1px solid #93c5fd',
        borderRadius: '6px',
        padding: '6px 4px',
      }}>
        <div style={{ 
          fontSize: '9px', 
          color: '#1e40af', 
          fontWeight: '700',
          marginBottom: '4px',
          textAlign: 'center',
        }}>
          📅 シフト確定
        </div>
        
        {/* シフト選択セレクター */}
        <select
  value={shiftMatrix[key] || ""}
  onChange={(e) => handleChange(empId, date, e.target.value)}
  style={{ 
    width: '100%',
    padding: '10px 8px',  // ✅ パディング増加
    borderRadius: '8px',
    border: '1px solid #93c5fd',
    fontSize: '15px',  // ✅ フォントサイズ拡大
    background: 'white',
    color: '#1e40af',
    fontWeight: '600',
    cursor: 'pointer',
    lineHeight: '1.8',  // ✅ 行間追加
    minHeight: '42px',  // ✅ 最小高さ指定
  }}
>
          {shiftOptions.map((opt, index) => (
            <option key={`shift-${index}-${opt}`} value={opt}>
              {opt === "" ? "日勤" : opt}
            </option>
          ))}
        </select>
      </div>
    </td>
  );
})}

        {/* 横レイアウトのシフト集計列 */}
        <td style={{ 
          padding: "8px",
          backgroundColor: "#f8fafc",
          borderLeft: "3px solid #e2e8f0",
          minWidth: "200px",
          position: "relative"
        }}>
          {renderStaffShiftSummaryHorizontal(empId)}
        </td>
      </tr>
    );
  })}
</tbody>
            </table>
          </div>
          </div>  {/* シフト表 tableContainer を閉じる */}
      </div>  {/* contentWrapper を閉じる */}
    </div> 
    )}  

    {/* モーダル（集中モード・通常モード共通） */}
    {showDailyOverrideModal && (
      <DailyRequirementOverrideModal
        isOpen={showDailyOverrideModal}
        onClose={() => setShowDailyOverrideModal(false)}
        organizationId={currentOrganization?.id}
        shiftPatterns={shiftPatterns}
        holidays={holidays}
        initialDate={dates?.[0]}
      />
    )}

    {showRecurringEventModal && (
      <RecurringEventModal
        isOpen={showRecurringEventModal}
        onClose={() => setShowRecurringEventModal(false)}
        initialDate={dates?.[0]}
      />
    )}

    {showAssignmentModal && autoAssignmentResult && (
      <ShiftAssignmentModal
        isOpen={showAssignmentModal}
        onClose={() => setShowAssignmentModal(false)}
        matrix={autoAssignmentResult.matrix}
        conflicts={autoAssignmentResult.conflicts || { off: {}, night: {} }}
        staffList={staffList}
        dates={dates}
        onSave={handleSaveAssignmentChanges}
        shiftOptions={shiftOptions}
        patterns={shiftPatterns}
        maxConsecutiveWorkDaysProp={settings?.holidayPolicy?.maxConsecutiveWorkDays}
        hopes={hopes}
        originalHopes={originalHopes}
        adminHopes={adminHopes}
        holidays={holidays}
        jobTypeFilter={lastJobTypeFilter}
        events={events}
      />
    )}

    {/* CSSアニメーション */}
<style>{`
  /* 集中モードのテーブルスクロールコンテナのみ */
  #focus-mode-scroll-container::-webkit-scrollbar {
    -webkit-appearance: none !important;
    width: 16px !important;
    height: 16px !important;
  }
  
  #focus-mode-scroll-container::-webkit-scrollbar-track {
    background: #1f2937 !important;
  }
  
  #focus-mode-scroll-container::-webkit-scrollbar-thumb {
    background: #4b5563 !important;
    border-radius: 8px !important;
    border: 3px solid #1f2937 !important;
  }
  
  #focus-mode-scroll-container::-webkit-scrollbar-thumb:hover {
    background: #6b7280 !important;
  }
  
  #focus-mode-scroll-container::-webkit-scrollbar-corner {
    background: #1f2937 !important;
  }
  
  /* Firefox用 */
  #focus-mode-scroll-container {
    scrollbar-width: auto !important;
    scrollbar-color: #4b5563 #1f2937 !important;
  }
  

  @keyframes pulse {
    0%, 100% { transform: translateX(-50%) scale(1); }
    50% { transform: translateX(-50%) scale(1.05); }
  }
  
  @keyframes blink {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.3; }
  }
  
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  /* 選択肢を超大型化 */
  select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
  }
  
  select option {
    font-size: 18px !important;
    padding: 16px 20px !important;
    line-height: 2.2 !important;
    min-height: 56px !important;
    cursor: pointer !important;
    font-weight: 600 !important;
    border-radius: 8px !important;
    margin: 4px 0 !important;
  }
  
  select option:hover {
    background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%) !important;
    color: #1e40af !important;
    transform: scale(1.02);
    transition: all 0.2s ease;
  }
  
  select option:checked {
    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important;
    color: white !important;
    font-weight: 700 !important;
  }
  
  select:focus {
    outline: 3px solid #60a5fa;
    outline-offset: 2px;
  }
  
  select::-webkit-scrollbar {
    width: 12px;
  }
  
  select::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 8px;
  }
  
  select::-webkit-scrollbar-thumb {
    background: #94a3b8;
    border-radius: 8px;
  }
  
  select::-webkit-scrollbar-thumb:hover {
    background: #64748b;
  }
`}</style>
    {/* 🧪 V2 試算モーダル (保存なし、既存 V1 と完全独立) */}
    <V2TrialModal
      open={v2TrialOpen}
      onClose={() => setV2TrialOpen(false)}
      organizationId={currentOrganization?.id}
      defaultYear={selectedYear}
      defaultMonth={currentMonth}
      jobTypes={jobTypes}
    />
  </>
);
}

export default Admin;